import React, { useEffect, useState } from "react";
import {
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    Grid,
    TextField,
    Divider,
    Typography,
    Box,
    Tooltip,
    IconButton,
    FormGroup,
    Switch,
    InputAdornment,
    Skeleton,
    tooltipClasses,
    Radio,
    RadioGroup,
    FormLabel,
    FormHelperText,
} from "@mui/material";
import { styled } from '@mui/material/styles';
import EditIcon from "@mui/icons-material/Edit";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { toast } from "react-toastify";
import { makeStyles } from "@mui/styles";
import AddIcon from "@mui/icons-material/Add";
import SelectableSearch from "../../../Base/views/SelectableSearch";
import DeleteIcon from "@mui/icons-material/Delete";
import { GetCustomDeductionAction, GetCustomEarningAction } from "../../../../../store/Finance/Component/Action";
import { useDispatch, useSelector } from "react-redux";
import Popup from "../../../Base/views/Popup";
import { AddPayrollTemplateAction, GetFoodAllowanceAction, GetLeaveWageAction, GetPayrollTemplateAction, GetPHAllowanceAction, GetTransportAllowanceAction } from "../../../../../store/Finance/PayRollTemplate/Action";
import { GetCalculateEmployeeSalaryTemplateAction, GetEmployeeTemplateAction } from "../../../../../store/Finance/Employee/Action";
import { GetEmployeesAction } from "../../../../../store/Employee/Employee/Action";
import {
    AddCalculateEmployeeAdvanceSalaryTemplateHelper, AddCalculateEmployeeContractualSalaryTemplateHelper, AddCalculateEmployeeContractualDailySalaryTemplateHelper,
    AddCalculateEmployeeSalaryTemplateHelper, AddEmployeeTemplateHelper, CalculateEmployeeAdvanceSalaryTemplateHelper, CalculateEmployeeContractualSalaryTemplateHelper,
    CalculateEmployeeContractualDailySalaryTemplateHelper, CalculateEmployeeSalaryTemplateHelper, onholdEmployeeHelper, UpdateEmployeeTemplateHelper, UpdateDailyWageTemplateHelper,
    CalculateContractualPayableDaysSalaryTemplateHelper, AddCalculateContractualPayableDaysSalaryTemplateHelper, GetEmployeePayrollTemplateDetailsHelper,
    CalculateMonthlyCtcTemplateHelper,
    AddCalculatemonthlyCtcTemplateHelper
} from "../../helper/Employee/EmployeeTemplateHelper";
import { GetContractualWageReportNotProcessedAction, GetWageReportNotProcessedAction } from "../../../../../store/Finance/Reports/Action";
import { GetOverTimeHelper } from "../../../FinanceSettings/helper/finance";
import { AllowanceInput, OvertimeSelector, shouldDisableEsic } from "./EmployeePayrollSubcomponents";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { GetEmployeePayrollProfileDetailHeper } from "../../../Employee/helper/EmployeeHelper";
import { getDomain } from "../../../Base/helper/baseFunctions";

const EmployeePayroleTemplate = ({ tab = true, filters, 
    empNotProcessed, // PayConfig is done; Payrun > Regular > NotProcessed
    contractualNotProcessed, // PayConfig is done; Payrun > Contractual > NotProcessed
    emp, // PayConfig is done; MyEmployee
    isonboard, createEmp, setOpenTemplate, openTemplate, currentData, setSuccessPopup, setOpenPopup, setCurrentMode, setInternal, callAllowanceAction = true, }) => {
    const useStyles = makeStyles({
        row: {
            display: "flex",
            flexDirection: "row",
        },
        label: {
            fontSize: "1rem",
            fontWeight: 400,
            width: "170px",
            flexShrink: 0,
            color: "rgb(99, 115, 129)",
            height: "30px",
            lineHeight: "30px",
            margin: "4px 0px 4px 0px",
        },
        netlabel: {
            fontSize: "1rem",
            fontWeight: "bold",
            width: "170px",
            flexShrink: 0,
            color: "#212B36",
            height: "30px",
            lineHeight: "30px",
            margin: "4px 0px 4px 0px",
        },

        value: {
            display: "flex",
            flexFlow: "row wrap",
            alignItems: "center",
            color: "rgb(99, 115, 129)",
        },
        flexAlignCenter: {
            paddingLeft: "15px",
            paddingRight: "15px",
            display: "flex",
            alignItems: "center",
        },
    });
    const LightTooltip = styled(({ className, placement = "right", ...props }) => (
        <Tooltip {...props} arrow placement={placement} classes={{ popper: className }} />
    ))(() => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#ffffff',
            color: '#333',
            boxShadow: '0px 4px 12px rgba(0,0,0,0.15)',
            fontSize: 13,
            borderRadius: 6,
            fontWeight: 400,
            padding: '8px 12px',
            maxWidth: 240,
            border: '1px solid #ddd',
        },
    }));

    const classes = useStyles();
    const initialValue = {
        template_name: "",
        save_as_template: false,
    };
    const templateEarningsValues = {
        earning_key: "",
        earning_value: "0",
    };
    const templateDeductionValues = {
        deduction_key: "",
        deduction_value: "0",
    };
    const initialValues = {
        payroll_worklocation_id: "",
        ctc: "",
        basic: 50,
        hra: 50,
        conveyance_allowance: 1250,
        medical_allowance: 1600,
        educational_allowance: 200,
        lta: "",
        conveyance_allowance_flag: false,
        medical_allowance_flag: false,
        educational_allowance_flag: false,
        lta_flag: false,
        esic: false,
        pt: false,
        variable_percentage: "",
        pf: false,
        eps_applicable_flag: false,
        pf_limit_applicable: false,
        pf_limit_amount: "25000",
        payroll_onhold: false,
        pf_earnings_applicable: false,
        leave_wages_applicable: false,
        ph_wages_applicable: false,
        transport_applicable: false,
        transport_earnings: false,
        transport_deductions: false,
        food_applicable: false,
        food_earnings: false,
        food_deductions: false,
        weekoff_caln_applicable: true,
        statutory_bonus_flag: false,
        gratuity_flag: false,
        pf_compliant_flag: true,
        monthly_working_hrs_calc: false,
        daily_wage_per_hr_amount: ""
    };
    const [selecttemp, setSelectTemp] = useState(false); // for advanced template (Annual)
    const [contractual, setContractual] = useState(false); // for contractual template
    const [contractualDaily, setContractualDaily] = useState(false); //for contractualDaily template
    const [contractualPayableDays, setContractualPayableDays] = useState(false); // for contractual payableDays
    const [venilatemplate, setVenilaTemplate] = useState(false); // for venila template
    const [dailyWagesTemplate, setDailyWagesTemplate] = useState(false); // daily wages template
    const [monthlyCtcTemplate, setMonthlyCtcTemplate] = useState(false); // monthly_ctc_autocalculator_template_applied Meepl Adv Monthly
    const [defaulttemplate, setDefaultTemplate] = useState(false); // for meepl basic + blueprint template adv
    const [isSending, setIsSending] = useState(false);
    const [onhold, setOnHold] = useState(false);
    const [msg, setMsg] = useState(false);
    const [step, setStep] = useState(1);
    const [resData, setResData] = useState("");
    const { leave_wage_data, transport_allowance_data, ph_allowance_data, food_allowance_data } = useSelector(state => state.FinanceReducer?.PayrollTemplateReducer);
    const formatNumber = (num) => {
        const number = Number(num);
        return isNaN(number) ? '0' : number.toLocaleString('en-IN');
    };
    const sanitizeNumber = (value) => {
        const numStr = String(value || '0').replace(/,/g, '');
        return parseFloat(numStr) || 0;
    };
    const checkSpecialAllowanceNegative = resData?.special_allowance ? +resData?.special_allowance < 0 : false;
    const earningsComp = [
        {
            label: "Basic",
            value: formatNumber(resData?.basic),
            annual_val: formatNumber(resData?.annual_basic)
        },
        {
            label: "HRA",
            value: formatNumber(resData?.hra),
            annual_val: formatNumber(resData?.annual_hra)
        },
        ...(selecttemp ? [{
            label: "Variable Pay",
            value: formatNumber(resData?.variable_pay),
            annual_val: formatNumber(resData?.annual_variable_pay)
        }] : []),
        {
            label: "Conveyance Allowance",
            value: formatNumber(resData?.conveyance_allowance_calculated),
            annual_val: formatNumber(resData?.annual_conveyance_allowance_calculated)
        },
        {
            label: "Medical Allowance",
            value: formatNumber(resData?.medical_allowance_calculated),
            annual_val: formatNumber(resData?.annual_medical_allowance_calculated)
        },
        {
            label: "Educational Allowance",
            value: formatNumber(resData?.education_allowance_calculated),
            annual_val: formatNumber(resData?.annual_education_allowance_calculated)
        },
        {
            label: "Special Allowance",
            value: formatNumber(resData?.special_allowance),
            annual_val: formatNumber(resData?.annual_special_allowance)
        },
        {
            label: "LTA",
            value: formatNumber(resData?.lta_calculated),
            annual_val: formatNumber(resData?.annual_lta_calculated)
        },
        {
            label: "EPF Earning",
            value: formatNumber(resData?.epf_earning),
            annual_val: formatNumber(resData?.annual_epf_earning)
        },
        {
            label: "ESI Earning",
            value: formatNumber(resData?.esi_earning),
            annual_val: formatNumber(resData?.annual_esi_earning)
        },
        // Add variable earnings variable_earnings
        // ...(Array.isArray(resData?.variable_earnings?.monthly)
        //     ? resData?.variable_earnings.monthly?.map(item => ({
        //         label: item?.label,
        //         value: formatNumber(item?.value),
        //         annual_val: formatNumber((parseFloat(item?.value) || 0) * 12)
        //     }))
        //     : []
        // ),
        ...((selecttemp || contractual || contractualDaily || contractualPayableDays || monthlyCtcTemplate)
            ? [
                ...(resData?.earning_component_json?.map(item => ({
                    label: item?.label,
                    value: formatNumber(item?.value),
                    annual_val: formatNumber(item?.value * 12), // Format computed annual value
                })) || []
                )]
            : []
        ),
        ...((defaulttemplate || contractual || contractualDaily || contractualPayableDays || monthlyCtcTemplate)
            ? [
                {
                    label: "Statutory Bonus",
                    value: formatNumber(resData?.statutory_bonus),
                    annual_val: formatNumber(resData?.annual_statutory_bonus)
                },
                {
                    label: "Ex-Gratia",
                    value: formatNumber(resData?.ex_gratia),
                    annual_val: formatNumber(resData?.annual_ex_gratia)
                },
            ]
            : []
        ),
    ];
    const deductionsComp = [
        {
            label: "EPF Deduction",
            value: formatNumber(resData?.epf_deduction),
            annual_val: formatNumber(resData?.annual_epf_deduction)
        },
        {
            label: "PT Deduction",
            value: formatNumber(resData?.pt_deduction),
            annual_val: formatNumber(resData?.annual_pt_deduction)
        },
        {
            label: "ESI Deduction",
            value: formatNumber(resData?.esi_deduction),
            annual_val: formatNumber(resData?.annual_esi_deduction)
        },
        ...((selecttemp || contractual || contractualDaily || contractualPayableDays || monthlyCtcTemplate)
            ? [
                ...(resData?.deduction_component_json?.map(item => ({
                    label: item?.label,
                    value: formatNumber(item?.value),
                    annual_val: formatNumber(item?.value * 12),
                })) || []
                )]
            : []
        )
    ];

    const allowances = [
        { label: "Conveyance Allowance", flagName: "conveyance_allowance_flag", valueName: "conveyance_allowance" },
        { label: "Medical Allowance", flagName: "medical_allowance_flag", valueName: "medical_allowance" },
        { label: "Educational Allowance", flagName: "educational_allowance_flag", valueName: "educational_allowance" },
        { label: "LTA", flagName: "lta_flag", valueName: "lta" },
    ];
    const activeMessage = contractualDaily
        ? {
            text: "For daily wage employees, enter 30 × daily rate in monthly fields",
            tooltip: "This ensures proper calculation of monthly amounts from daily rates",
        }
        : contractualPayableDays
            ? {
                text: "For configuration, salary values are displayed on a 30-day basis for standardization. Actual salary is calculated on the month’s payable days.",
                tooltip: "We will ask payable days as input during payroll run.",
            }
            : contractual
                ? {
                    text: "Contract-based salary structure with direct earning inputs, independent of CTC and options for leave, holiday, and weekly-off pay.",
                    tooltip: "",
                }
                : selecttemp
                    ? {
                        text: "Flexible salary structure for full-time employees allowing optional additional earnings, variable pay and custom deductions.",
                        tooltip: "",
                    }
                    : defaulttemplate
                        ? {
                            text: "Standard salary structure for full-time employees with Basic, HRA, default allowances and statutory components.",
                            tooltip: "",
                        }
                        : monthlyCtcTemplate
                            ? {
                                text: "Monthly CTC-based salary structure allowing configurable earnings and deductions, statutory toggles, and automatic monthly and annual CTC computation.",
                                tooltip: "",
                            }
                            : null;


    const calculateTotal = (items) => items?.reduce((total, item) => total + sanitizeNumber(item?.value), 0);
    const calculateTotal2 = (items) => items?.reduce((total, item) => {
        if (item?.earning_key) {
            return total + sanitizeNumber(item?.earning_value);
        }
        return total;
    }, 0);
    const grossEarningsTempTotal = calculateTotal(earningsComp);
    const grossDeductionsTempTotal = calculateTotal(deductionsComp);
    const netTempTotal = grossEarningsTempTotal - grossDeductionsTempTotal;
    const formattedGrossEarnings = formatNumber(grossEarningsTempTotal);
    const formattedGrossDeductions = formatNumber(grossDeductionsTempTotal);
    const formattedNetTotal = formatNumber(netTempTotal);
    const [templateEarningData, setTemplateEarningData] = useState([]);
    const monthlyCtcAutoTotalCalc = monthlyCtcTemplate && calculateTotal2(templateEarningData);
    const [templateDeductionData, setTemplateDeductionData] = useState([]);
    const [opentempname, setOpenTempname] = useState(false);
    const [openvalid, setOpenValid] = useState(false);
    const [templatename, setTemplatename] = useState(initialValue);
    const [template, setTemplate] = useState(initialValues);
    const [overtime, setOverTime] = useState({ overtime_applicable_flag: false, overtime_configuration_pk: "" });
    const [temperrors, setTempErrors] = useState({});
    const [inputData, setInputData] = useState({ template_id: "" });
    const [errors, setErrors] = useState({});
    const [templateEarningErrors, setTemplateEarningErrors] = useState([]);
    const [templateDeductionErrors, setTemplateDeductionErrors] = useState([]);
    const [disabledEarningTemplate, setDisabledEarningTemplate] = useState(false);
    const [disabledDeductionTemplate, setDisabledDeductionTemplate] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [grossEarningsTotal, setGrossEarningsTotal] = useState(0);
    const [grossDeductionsTotal, setGrossDeductionsTotal] = useState(0);
    const [netTotal, setNetTotal] = useState(0);
    const [earningData, setEarningData] = useState({ load: true, values: [], });
    const [deductionData, setDeductionData] = useState({ load: true, values: [], });
    const [templateData, setTemplateData] = useState({ load: true, values: [] });
    const [esicInfo, setEsicInfo] = useState({ toggle: false, lastModified: null });
    const [isLoading2, setIsLoading2] = useState(false);
    const dispatch = useDispatch();
    const [currentDataTemp, setCurrentDataTemp] = useState({});
    const [empRegNumber, setEmpRegNumber] = useState({
        pf_no: "",
        esi_no: "",
        uan: null
    })
    const [overtimeOptionData, setOvertimeOptionData] = useState({ load: true, values: [] });
    const handleToggle = (field) => {
        const defaultValues = {
            conveyance_allowance: 1250,
            medical_allowance: 1600,
            educational_allowance: 200,
        };
        setTemplate((prevState) => {
            const newState = { ...prevState, [field]: !prevState[field] };
            const fieldName = field?.replace('_flag', '');
            if (newState[field]) {
                newState[fieldName] = defaultValues[fieldName] || '';
            } else {
                newState[fieldName] = '';
            }
            return newState;
        });
    };
    const handleToggle1 = (field) => {
        setTemplate((prevState) => {
            const newState = {
                ...prevState,
                [field]: !prevState[field],
                pf_earnings_applicable: field === "pf" ? !prevState[field] : prevState.pf_earnings_applicable
            };

            if (field === "pf") {
                if (!newState.pf) {
                    newState.pf_limit_applicable = false;
                    newState.pf_limit_amount = "25000";
                    newState.eps_applicable_flag = false;
                }
                if (newState.pf) {
                    newState.pf_compliant_flag = true; // Set compliant flag to true when PF is enabled
                    newState.eps_applicable_flag = true;
                }
            }
            return newState;
        });
    };

    const handleToggleOnHold = (field) => {
        setTemplate((prevState) => {
            const newState = { ...prevState, [field]: !prevState[field] };
            if (!prevState[field]) {
                setMsg(`Confirm placing ${currentData?.name}'s salary on hold?`);
            } else {
                setMsg(`Are you sure you want to release the hold on ${currentData?.name}'s salary?`);
            }
            return newState;
        });

        setOnHold(true);
    };
    useEffect(() => {
        const allFieldsEmpty = templateEarningData?.every(
            (field) =>
                field?.earning_key !== "" &&
                field?.earning_value !== ""
        );
        setDisabledEarningTemplate(!allFieldsEmpty);
    }, [templateEarningData]);
    useEffect(() => {
        const allFieldsEmpty = templateDeductionData?.every(
            (field) =>
                field?.deduction_key !== "" &&
                field?.deduction_value !== ""
        );
        setDisabledDeductionTemplate(!allFieldsEmpty);
    }, [templateDeductionData]);
    useEffect(() => {
        if (monthlyCtcTemplate) {
            setTemplate({ ...template, ctc: 12 * monthlyCtcAutoTotalCalc })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [monthlyCtcAutoTotalCalc])
    const { custom_earning_data, custom_deduction_data } = useSelector(
        (state) => state?.FinanceReducer.ComponentReducer
    );
    const { employee_template_data, calculate_salary_employee_template_data, isLoading } = useSelector(
        (state) => state?.FinanceReducer.EmployeeTemplateReducer
    );
    const { payroll_template_data } = useSelector(
        (state) => state?.FinanceReducer.PayrollTemplateReducer
    );
    const findSelectedTemplateName = (templatename) => {
        return templatename ? payroll_template_data?.find(t => t?.template_name === templatename)?.template_id : ""
    }

    useEffect(() => {
        dispatch(GetCustomEarningAction());
        dispatch(GetCustomDeductionAction());
        setIsLoading2(true);
        GetEmployeePayrollTemplateDetailsHelper({ employee_id: currentData?.employee_id }).then((res) => {
            if (res?.data?.statuscode === 200) {
                const currentTempData = res?.data?.data?.[0] || {};
                setCurrentDataTemp({ ...currentTempData });
                setTemplate((prev) => ({...prev, daily_wage_per_hr_amount: currentTempData?.daily_wage_hourly_amt}))
                if (currentTempData?.payroll_blueprint_applied || currentTempData?.payroll_advanced_blueprint_applied || currentTempData?.payroll_contractual_template_applied
                    || currentTempData?.payroll_contractual_daily_template_applied || currentTempData?.payroll_contractual_custom_payable_template_applied ||
                    currentTempData?.payroll_monthly_ctc_autocalculator_template_applied
                ) {
                    dispatch(GetCalculateEmployeeSalaryTemplateAction({
                        employee_id: currentData?.employee_id
                    }));
                } else if (currentTempData?.payroll_daily_wages_template) {
                    // Do nothing, just validate the condition
                }
                else {
                    dispatch(GetEmployeeTemplateAction({
                        employee_id: currentData?.employee_id
                    }));
                }
            } else {
                toast.error("Something went wrong!")
            }
            setIsLoading2(false);
        })
        if (callAllowanceAction) {
            dispatch(GetPayrollTemplateAction())
            dispatch(GetLeaveWageAction());
            dispatch(GetTransportAllowanceAction());
            dispatch(GetPHAllowanceAction());
            dispatch(GetFoodAllowanceAction());
        }
        GetEmployeePayrollProfileDetailHeper({
            domain: getDomain(),
            employee_id: currentData?.employee_id
        })
            .then((res) => {
                if (res?.data?.statuscode === 200) {
                    setEmpRegNumber({
                        pf_no: res?.data?.data?.[0]?.pf_no,
                        esi_no: res?.data?.data?.[0]?.esi_no,
                        uan: res?.data?.data?.[0]?.uan_no
                    })
                } else {
                    setEmpRegNumber({
                        pf_no: "",
                        esi_no: "",
                        uan: null
                    })
                }
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        let totalEarnings = 0;
        let totalDeductions = 0;
        if (!currentDataTemp?.payroll_blueprint_applied && !currentDataTemp?.payroll_advanced_blueprint_applied && !currentDataTemp?.payroll_contractual_template_applied
            && !currentDataTemp?.payroll_contractual_daily_template_applied && !currentDataTemp?.payroll_daily_wages_template && !currentDataTemp?.payroll_contractual_custom_payable_template_applied &&
            !currentDataTemp?.payroll_monthly_ctc_autocalculator_template_applied
        ) {
            const resDataEmp = employee_template_data?.[0];
            if (employee_template_data?.length > 0) {
                setVenilaTemplate(true);
                setDefaultTemplate(false);
                setSelectTemp(false);
                setContractual(false);
                setContractualPayableDays(false);
                setContractualDaily(false);
                setDailyWagesTemplate(false);
                setMonthlyCtcTemplate(false);
                setOverTime({
                    overtime_applicable_flag: resDataEmp?.overtime_applicable,
                    overtime_configuration_pk: resDataEmp?.overtime_configuration_fk ? { overtime_configuration_pk: resDataEmp?.overtime_configuration_fk, alias_name: resDataEmp?.overtime_configuration_name } : ""
                })
                setTemplate({
                    ...template,
                    payroll_onhold: resDataEmp?.payroll_onhold
                })
                const earnings = resDataEmp?.earnings;
                const deductions = resDataEmp?.deductions;
                if (earnings) {
                    const earningFields = Object.entries(earnings || {})
                        ?.filter(([key, value]) => value?.value != null)
                        ?.map(([key, value]) => {
                            return {
                                earning_key: {
                                    label: value?.label,
                                    name: value?.name,
                                },
                                earning_value: value?.value
                            };
                        });
                    setTemplateEarningData(earningFields);
                    setDisabled(true);
                    totalEarnings = earningFields?.reduce((sum, field) => sum + (field?.earning_value || 0), 0);
                    setGrossEarningsTotal(totalEarnings);

                }
                if (deductions) {
                    const deductionFields = Object.entries(deductions || {})
                        ?.filter(([key, value]) => value?.value != null)
                        ?.map(([key, value]) => {
                            return {
                                deduction_key: {
                                    label: value?.label,
                                    name: value?.name,
                                },
                                deduction_value: value?.value
                            };
                        });
                    setTemplateDeductionData(deductionFields);
                    setDisabled(true);
                    totalDeductions = deductionFields?.reduce((sum, field) => sum + (field?.deduction_value || 0), 0);
                    setGrossDeductionsTotal(totalDeductions);
                }
                setNetTotal(totalEarnings - totalDeductions);
                setInputData({
                    ...inputData,
                    template_id: ""
                });
            }
            else {
                setDisabled(false);
                setTemplateEarningData([]);
                setTemplateDeductionData([]);
                setGrossEarningsTotal(0);
                setGrossDeductionsTotal(0);
                setNetTotal(0);
                setDefaultTemplate(true);
                setVenilaTemplate(false);
                setSelectTemp(false);
                setContractual(false);
                setContractualPayableDays(false);
                setContractualDaily(false);
                setDailyWagesTemplate(false);
                setMonthlyCtcTemplate(false);
                setTemplate({
                    ...initialValues
                });
                setInputData({
                    ...inputData,
                    template_id: { template_id: findSelectedTemplateName("Meepl Salary Template"), template_name: "Meepl Salary Template" },
                });
                setOverTime({ overtime_applicable_flag: false, overtime_configuration_pk: "" })
            }

        } else if (currentDataTemp?.payroll_daily_wages_template) {
            setSelectTemp(false);
            setDefaultTemplate(false);
            setContractual(false);
            setContractualPayableDays(false);
            setContractualDaily(false);
            setDailyWagesTemplate(true);
            setMonthlyCtcTemplate(false);
            setInputData({
                ...inputData,
                template_id: { template_id: findSelectedTemplateName("Work-Based Pay"), template_name: "Work-Based Pay" },
            });
            setTemplateEarningData([])
            setTemplateDeductionData([])
        } else if (
            calculate_salary_employee_template_data?.length > 0
        ) {
            if (currentDataTemp?.payroll_blueprint_applied || currentDataTemp?.payroll_advanced_blueprint_applied || currentDataTemp?.payroll_contractual_template_applied
                || currentDataTemp?.payroll_contractual_daily_template_applied || currentDataTemp?.payroll_contractual_custom_payable_template_applied ||
                currentDataTemp?.payroll_monthly_ctc_autocalculator_template_applied) {
                const resDataBlueprint = calculate_salary_employee_template_data?.[0];
                if (currentDataTemp?.payroll_advanced_blueprint_applied) {
                    setSelectTemp(true);
                    setDefaultTemplate(true)
                    setContractual(false);
                    setContractualPayableDays(false);
                    setContractualDaily(false);
                    setDailyWagesTemplate(false);
                    setMonthlyCtcTemplate(false);
                    setInputData({
                        ...inputData,
                        template_id: { template_id: findSelectedTemplateName("Advanced Meepl Salary Template : Annual"), template_name: "Advanced Meepl Salary Template : Annual" },
                    });
                    const earnings = calculate_salary_employee_template_data?.[0]?.earning_component_json;
                    const deductions = calculate_salary_employee_template_data?.[0]?.deduction_component_json;
                    if (earnings) {
                        const earningFields = Object.entries(earnings || {})
                            ?.filter(([key, value]) => value?.value != null)
                            ?.map(([key, value]) => {
                                return {
                                    earning_key: {
                                        label: value?.label,
                                        name: value?.name,
                                    },
                                    earning_value: value?.value
                                };
                            });
                        setTemplateEarningData(earningFields);
                    }
                    if (deductions) {
                        const deductionFields = Object.entries(deductions || {})
                            ?.filter(([key, value]) => value?.value != null)
                            ?.map(([key, value]) => {
                                return {
                                    deduction_key: {
                                        label: value?.label,
                                        name: value?.name,
                                    },
                                    deduction_value: value?.value
                                };
                            });
                        setTemplateDeductionData(deductionFields);
                    }
                } else if (currentDataTemp?.payroll_contractual_template_applied) {
                    setSelectTemp(false);
                    setDefaultTemplate(false);
                    setContractual(true);
                    setContractualPayableDays(false);
                    setContractualDaily(false);
                    setDailyWagesTemplate(false);
                    setMonthlyCtcTemplate(false);
                    setInputData({
                        ...inputData,
                        template_id: { template_id: findSelectedTemplateName("Contractual Template"), template_name: "Contractual Template" },
                    });
                    const earnings = calculate_salary_employee_template_data?.[0]?.earning_component_json;
                    const deductions = calculate_salary_employee_template_data?.[0]?.deduction_component_json;
                    if (earnings) {
                        const earningFields = Object.entries(earnings || {})
                            ?.filter(([key, value]) => value?.value != null)
                            ?.map(([key, value]) => {
                                return {
                                    earning_key: {
                                        label: value?.label,
                                        name: value?.name,
                                    },
                                    earning_value: value?.value
                                };
                            });
                        setTemplateEarningData(earningFields);
                    }
                    if (deductions) {
                        const deductionFields = Object.entries(deductions || {})
                            ?.filter(([key, value]) => value?.value != null)
                            ?.map(([key, value]) => {
                                return {
                                    deduction_key: {
                                        label: value?.label,
                                        name: value?.name,
                                    },
                                    deduction_value: value?.value
                                };
                            });
                        setTemplateDeductionData(deductionFields);
                    }
                } else if (currentDataTemp?.payroll_contractual_daily_template_applied) {
                    setContractualDaily(true);
                    setSelectTemp(false);
                    setDefaultTemplate(false);
                    setContractual(false);
                    setContractualPayableDays(false);
                    setDailyWagesTemplate(false);
                    setMonthlyCtcTemplate(false);
                    setInputData({
                        ...inputData,
                        template_id: { template_id: findSelectedTemplateName("Contractual Template : Daily Fixed"), template_name: "Contractual Template : Daily Fixed" },
                    });
                    const earnings = calculate_salary_employee_template_data?.[0]?.earning_component_json;
                    const deductions = calculate_salary_employee_template_data?.[0]?.deduction_component_json;
                    if (earnings) {
                        const earningFields = Object.entries(earnings || {})
                            ?.filter(([key, value]) => value?.value != null)
                            ?.map(([key, value]) => {
                                return {
                                    earning_key: {
                                        label: value?.label,
                                        name: value?.name,
                                    },
                                    earning_value: value?.value
                                };
                            });
                        setTemplateEarningData(earningFields);
                    }
                    if (deductions) {
                        const deductionFields = Object.entries(deductions || {})
                            ?.filter(([key, value]) => value?.value != null)
                            ?.map(([key, value]) => {
                                return {
                                    deduction_key: {
                                        label: value?.label,
                                        name: value?.name,
                                    },
                                    deduction_value: value?.value
                                };
                            });
                        setTemplateDeductionData(deductionFields);
                    }
                } else if (currentDataTemp?.payroll_contractual_custom_payable_template_applied) {
                    setContractualPayableDays(true);
                    setSelectTemp(false);
                    setDefaultTemplate(false);
                    setContractual(false);
                    setContractualDaily(false);
                    setDailyWagesTemplate(false);
                    setMonthlyCtcTemplate(false);
                    setInputData({
                        ...inputData,
                        template_id: { template_id: findSelectedTemplateName("Contractual Template : Payable Days"), template_name: "Contractual Template : Payable Days" },
                    });
                    const earnings = calculate_salary_employee_template_data?.[0]?.earning_component_json;
                    const deductions = calculate_salary_employee_template_data?.[0]?.deduction_component_json;
                    if (earnings) {
                        const earningFields = Object.entries(earnings || {})
                            ?.filter(([key, value]) => value?.value != null)
                            ?.map(([key, value]) => {
                                return {
                                    earning_key: {
                                        label: value?.label,
                                        name: value?.name,
                                    },
                                    earning_value: value?.value
                                };
                            });
                        setTemplateEarningData(earningFields);
                    }
                    if (deductions) {
                        const deductionFields = Object.entries(deductions || {})
                            ?.filter(([key, value]) => value?.value != null)
                            ?.map(([key, value]) => {
                                return {
                                    deduction_key: {
                                        label: value?.label,
                                        name: value?.name,
                                    },
                                    deduction_value: value?.value
                                };
                            });
                        setTemplateDeductionData(deductionFields);
                    }
                } else if (currentDataTemp?.payroll_monthly_ctc_autocalculator_template_applied) {
                    setSelectTemp(false);
                    setDefaultTemplate(false)
                    setContractual(false);
                    setContractualPayableDays(false);
                    setContractualDaily(false);
                    setDailyWagesTemplate(false)
                    setMonthlyCtcTemplate(true);
                    setInputData({
                        ...inputData,
                        template_id: { template_id: findSelectedTemplateName("Advanced Meepl Salary Template : Monthly"), template_name: "Advanced Meepl Salary Template : Monthly" },
                    });
                    const earnings = calculate_salary_employee_template_data?.[0]?.earning_component_json;
                    const deductions = calculate_salary_employee_template_data?.[0]?.deduction_component_json;
                    if (earnings) {
                        const earningFields = Object.entries(earnings || {})
                            ?.filter(([key, value]) => value?.value != null)
                            ?.map(([key, value]) => {
                                return {
                                    earning_key: {
                                        label: value?.label,
                                        name: value?.name,
                                    },
                                    earning_value: value?.value
                                };
                            });
                        setTemplateEarningData(earningFields);
                    }
                    if (deductions) {
                        const deductionFields = Object.entries(deductions || {})
                            ?.filter(([key, value]) => value?.value != null)
                            ?.map(([key, value]) => {
                                return {
                                    deduction_key: {
                                        label: value?.label,
                                        name: value?.name,
                                    },
                                    deduction_value: value?.value
                                };
                            });
                        setTemplateDeductionData(deductionFields);
                    }
                } else {
                    setInputData({
                        ...inputData,
                        template_id: { template_id: findSelectedTemplateName("Meepl Salary Template"), template_name: "Meepl Salary Template" },
                    });
                    setSelectTemp(false);
                    setDefaultTemplate(true);
                    setContractual(false);
                    setContractualPayableDays(false);
                    setContractualDaily(false);
                    setDailyWagesTemplate(false);
                    setMonthlyCtcTemplate(false);
                }
                setVenilaTemplate(false);
                setOverTime({
                    overtime_applicable_flag: resDataBlueprint?.overtime_applicable,
                    overtime_configuration_pk: resDataBlueprint?.overtime_configuration_fk ? { overtime_configuration_pk: resDataBlueprint?.overtime_configuration_fk, alias_name: resDataBlueprint?.overtime_configuration_name } : ""
                })
                setTemplate({
                    ...resDataBlueprint,
                    basic: resDataBlueprint?.basic_percentage,
                    hra: resDataBlueprint?.hra_percentage,
                    educational_allowance: resDataBlueprint?.education_allowance,
                    esic: resDataBlueprint?.esic_flag,
                    pt: resDataBlueprint?.pt_flag,
                    lta: resDataBlueprint?.lta,
                    pf: resDataBlueprint?.pf_flag,
                    pf_earnings_applicable: resDataBlueprint?.pf_flag,
                    eps_applicable_flag: resDataBlueprint?.eps_applicable_flag || false,
                    pf_limit_applicable: resDataBlueprint?.pf_limit_applicable_flag,
                    ph_wages_applicable: resDataBlueprint?.ph_calculation_flag,
                    transport_applicable: resDataBlueprint?.transport_flag,
                    transport_earnings: resDataBlueprint?.transport_earning,
                    transport_deductions: resDataBlueprint?.transport_deduction,
                    food_applicable: resDataBlueprint?.food_applicable,
                    food_earnings: resDataBlueprint?.food_earning,
                    food_deductions: resDataBlueprint?.food_deduction,
                    weekoff_caln_applicable: resDataBlueprint?.week_off_caln_applicable,
                    monthly_working_hrs_calc: resDataBlueprint?.working_hrs_monthly_caln
                });
                setEsicInfo({ toggle: resDataBlueprint?.esic_flag, lastModified: resDataBlueprint?.esic_modifiedon })
            }
            else {
                setDisabled(false);
                setTemplateEarningData([]);
                setTemplateDeductionData([]);
                setGrossEarningsTotal(0);
                setGrossDeductionsTotal(0);
                setNetTotal(0);
                setDefaultTemplate(true);
                setSelectTemp(false);
                setContractual(false);
                setContractualPayableDays(false);
                setContractualDaily(false);
                setVenilaTemplate(false);
                setDailyWagesTemplate(false);
                setMonthlyCtcTemplate(false);
                setInputData({
                    ...inputData,
                    template_id: { template_id: findSelectedTemplateName("Meepl Salary Template"), template_name: "Meepl Salary Template" },
                });
                setOverTime({ overtime_applicable_flag: false, overtime_configuration_pk: "" })
            }
        }
        else {
            setDisabled(false);
            setTemplateEarningData([]);
            setTemplateDeductionData([]);
            setGrossEarningsTotal(0);
            setGrossDeductionsTotal(0);
            setNetTotal(0);
            setDefaultTemplate(true);
            setSelectTemp(false);
            setContractual(false);
            setContractualPayableDays(false);
            setContractualDaily(false);
            setVenilaTemplate(false);
            setDailyWagesTemplate(false);
            setMonthlyCtcTemplate(false);
            setTemplate({
                ...initialValues
            });
            setInputData({
                ...inputData,
                template_id: { template_id: findSelectedTemplateName("Meepl Salary Template"), template_name: "Meepl Salary Template" },
            });
            setOverTime({ overtime_applicable_flag: false, overtime_configuration_pk: "" })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [employee_template_data, calculate_salary_employee_template_data, currentDataTemp]);
    const handleInputChange = (event, value) => {

        if (["save_as_template"].includes(event?.target?.name)) {
            setTemplatename({
                ...templatename,
                [event.target.name]: event.target.checked,
            });
        } else {
            setTemplatename({
                ...templatename,
                [event?.target?.name]: event?.target?.value,
            });
        }
    };
    const handleInputChange1 = (event, value) => {
        if (["overtime_applicable_flag"].includes(event?.target?.name)) {
            const checked = event.target.checked;
            setOverTime((prev) => ({
                ...prev,
                [event.target.name]: checked,
                overtime_configuration_pk: checked ? prev.overtime_configuration_pk : ""
            }));
        } else if (
            ["leave_wages_applicable", "ph_wages_applicable", "transport_applicable", "food_applicable", "weekoff_caln_applicable", "monthly_working_hrs_calc"].includes(event?.target?.name)
        ) {
            const { name, checked } = event.target;
            setTemplate((prev) => {
                let updated = { ...prev, [name]: checked };
                // If turning off transport calculation, reset transport_type
                if (name === "transport_applicable") {
                    if (checked) {
                        updated.transport_earnings = true;
                        updated.transport_deductions = false;
                    } else {
                        updated.transport_earnings = false;
                        updated.transport_deductions = false;
                    }
                    setDuplicateError(prev => ({
                        ...prev,
                        transport_applicable: ""
                    }));
                }
                if (name === "food_applicable") {
                    if (checked) {
                        updated.food_earnings = true;
                        updated.food_deductions = false;
                    } else {
                        updated.food_earnings = false;
                        updated.food_deductions = false;
                    }
                    setDuplicateError(prev => ({
                        ...prev,
                        food_applicable: ""
                    }));
                }
                return updated;
            });
        } else if (event?.target?.name === "transport_type") {
            setTemplate((prev) => ({
                ...prev,
                transport_earnings: event.target.value === "earning",
                transport_deductions: event.target.value === "deduction",
            }));
        } else if (event?.target?.name === "food_type") {
            setTemplate((prev) => ({
                ...prev,
                food_earnings: event.target.value === "earning",
                food_deductions: event.target.value === "deduction",
            }));
        } else if (["daily_wage_per_hr_amount"].includes(event.target.name)) {
            setTemplate((prev) => ({
                ...prev,
                [event.target.name]: event.target.value,
            }));
            Object.values?.(errors)?.find(res => res !== "")?.length > 0 &&
            validate({ ...template, [event.target.name]: event.target.value });
        } else {
            setOverTime({
                ...overtime,
                [event.target.name]: event.target.value,
            });
        }
    };
    const callDependencyFetch = () => { // PayConfig is done from MyEmployee/PayRun > Regular/Contractual > NotProcessed : dependency fn to be called
        if (empNotProcessed) {
            const [f_year, month] = filters?.month_year?.split("-");
            const f_month = parseInt(month, 10)?.toString();
            dispatch(GetWageReportNotProcessedAction({ month: f_month, year: f_year }));
            toast.success(`${currentData?.name}'s payroll setup is now complete`, { duration: 2000, });
        }
        if (contractualNotProcessed) {
            const [f_year, month] = filters?.month_year?.split("-");
            const f_month = parseInt(month, 10)?.toString();
            dispatch(GetContractualWageReportNotProcessedAction({ month: f_month, year: f_year }));
            toast.success(`${currentData?.name}'s payroll setup is now complete`, { duration: 2000, });
        }
        if (emp) {
            dispatch(GetEmployeesAction({ is_active: tab }));
        }

    }
    const handleSubmit = () => {
        if (!tempvalidate({}, overtime)) return
        if (templatename?.save_as_template) {
            const isEarningsValid = Earningvalidate();
            const isDeductionsValid = Deductionvalidate();
            if (isEarningsValid && isDeductionsValid) {
                setOpenTempname(true);
                setIsSending(true);
            }
        }
        else {
            const isEarningsValid = Earningvalidate();
            const isDeductionsValid = Deductionvalidate();
            if (isEarningsValid && isDeductionsValid) {
                const EarningformattedData = templateEarningData?.reduce((acc, item) => {
                    if (item?.earning_key?.name && item?.earning_value) {
                        acc[item.earning_key.name] = item.earning_value;
                    }
                    return acc;
                }, {});
                const DeductionformattedData = templateDeductionData?.reduce((acc, item) => {
                    if (item?.deduction_key?.name && item?.deduction_value) {
                        acc[item.deduction_key.name] = item.deduction_value;
                    }
                    return acc;
                }, {});
                if (employee_template_data?.length > 0) {
                    UpdateEmployeeTemplateHelper({
                        earnings: JSON.stringify([EarningformattedData]),
                        deductions: JSON.stringify([DeductionformattedData]),
                        employee_id: currentData?.employee_id,
                        overtime_applicable_flag: overtime?.overtime_applicable_flag,
                        payroll_onhold: template?.payroll_onhold,
                        overtime_configuration_pk: overtime?.overtime_applicable_flag ? overtime?.overtime_configuration_pk?.overtime_configuration_pk : null,
                    }).then((res) => {
                        if (res?.data?.statuscode === 200) {
                            setIsSending(false);
                            callDependencyFetch()
                        }
                    });
                }
                else {
                    AddEmployeeTemplateHelper({
                        earnings: JSON.stringify([EarningformattedData]),
                        deductions: JSON.stringify([DeductionformattedData]),
                        employee_id: currentData?.employee_id,
                        overtime_applicable_flag: overtime?.overtime_applicable_flag,
                        payroll_onhold: template?.payroll_onhold,
                        overtime_configuration_pk: overtime?.overtime_applicable_flag ? overtime?.overtime_configuration_pk?.overtime_configuration_pk : null,
                    }).then((res) => {
                        setIsSending(false);
                        if (res?.data?.statuscode === 200) {
                            callDependencyFetch()
                        }
                    });
                }
                setOpenTemplate(false);
                if (createEmp) {
                    setOpenPopup(false);
                    setSuccessPopup(false)
                }
                else if (isonboard) {
                    setCurrentMode("grid");
                    setInternal(true)
                }
            }
        }
    };
    const validate = (fieldValues) => {
        let temp = { ...errors };
        if ("template_name" in fieldValues) {
            temp.template_name = fieldValues.template_name === "" ? "Template Name is required" : "";
        }
        if ("daily_wage_per_hr_amount" in fieldValues && dailyWagesTemplate) {
            temp.daily_wage_per_hr_amount = fieldValues.daily_wage_per_hr_amount === "" ? "Per hr amount is required" : "";
        } else {
            temp.daily_wage_per_hr_amount = ""
        }
        setErrors({
            ...temp,
        });
        return Object.values(temp).every((x) => x === "");
    };
    const handleCreateTemplate = () => {
        if (validate(templatename) && validateTemplateName(templatename)) {
            setIsSending(true);
            const EarningformattedData = templateEarningData?.reduce((acc, item) => {
                if (item?.earning_key?.name && item?.earning_value) {
                    acc[item.earning_key.name] = item.earning_value;
                }
                return acc;
            }, {});
            const DeductionformattedData = templateDeductionData?.reduce((acc, item) => {
                if (item?.deduction_key?.name && item?.deduction_value) {
                    acc[item.deduction_key.name] = item.deduction_value;
                }
                return acc;
            }, {});
            const earningKeys = templateEarningData?.map(item => item.earning_key)?.filter(Boolean);
            const deductionKeys = templateDeductionData?.map(item => item.deduction_key)?.filter(Boolean);
            const templateFields = JSON.stringify({
                earning_key: earningKeys,
                deduction_key: deductionKeys
            });

            dispatch(AddPayrollTemplateAction({
                template_name: templatename?.template_name,
                template_fields: templateFields
            }));
            if (employee_template_data?.length > 0) {
                UpdateEmployeeTemplateHelper({
                    earnings: JSON.stringify([EarningformattedData]),
                    deductions: JSON.stringify([DeductionformattedData]),
                    employee_id: currentData?.employee_id,
                    overtime_applicable_flag: overtime?.overtime_applicable_flag,
                    payroll_onhold: template?.payroll_onhold,
                    overtime_configuration_pk: overtime?.overtime_applicable_flag ? overtime?.overtime_configuration_pk?.overtime_configuration_pk : null,
                }).then((res) => {
                    if (res?.data?.statuscode === 200) {
                        setIsSending(false);
                        callDependencyFetch();
                    }
                });
            }
            else {
                AddEmployeeTemplateHelper({
                    earnings: JSON.stringify([EarningformattedData]),
                    deductions: JSON.stringify([DeductionformattedData]),
                    employee_id: currentData?.employee_id,
                    overtime_applicable_flag: overtime?.overtime_applicable_flag,
                    payroll_onhold: template?.payroll_onhold,
                    overtime_configuration_pk: overtime?.overtime_applicable_flag ? overtime?.overtime_configuration_pk?.overtime_configuration_pk : null,
                }).then((res) => {
                    if (res?.data?.statuscode === 200) {
                        setIsSending(false);
                        callDependencyFetch();
                    }
                });
            }
            setOpenTemplate(false);
            setOpenTempname(false);
           
            if (createEmp) {
                setOpenPopup(false);
                setSuccessPopup(false)
            }
            else if (isonboard) {
                setCurrentMode("grid");
                setInternal(true)
            }
        }
    };
    //Earning Template Name Section
    const handleAddEarningFields = () => {
        setTemplateEarningData((state) => [...state, templateEarningsValues]);
    };
    const handleEarningDelete = (e, id, deleteid) => {
        let Data = [...templateEarningData];
        Data.splice(id, 1);
        setTemplateEarningData(Data);
        const newGrossEarningsTotal = Data?.reduce((total, item) => {
            return total + (parseFloat(item?.earning_value) || 0);
        }, 0);
        setGrossEarningsTotal(newGrossEarningsTotal);
        const newNetTotal = newGrossEarningsTotal - grossDeductionsTotal;
        setNetTotal(newNetTotal);
    };
    const Earningvalidate = () => {
        let isValid = true;
        const newErrors = [...templateEarningErrors];
        templateEarningData?.forEach((store, index) => {
            const error = {};
            if (!store?.earning_key) {
                error.earning_key = "Name is required";
                isValid = false;
            }
            if (!store?.earning_value) {
                error.earning_value = "Value is required";
                isValid = false;
            }
            while (newErrors?.length <= index) {
                newErrors.push({});
            }
            newErrors[index] = error;
        });
        setTemplateEarningErrors(newErrors);
        return isValid;
    };
    // work
    const handleEarningChange = (e, value, id) => {
        let newArr = [...templateEarningData];
        const newErrors = [...templateEarningErrors];
        let item = newArr[id];
        item = { ...item, [e]: value };
        newArr[id] = item;
        newErrors[id] = { ...newErrors[id], [e]: "" };
        setTemplateEarningData(newArr);
        setTemplateEarningErrors(newErrors);
        const newGrossEarningTotal = newArr?.reduce((total, item) => {
            return total + (parseFloat(item?.earning_value) || 0);
        }, 0);
        setGrossEarningsTotal(newGrossEarningTotal);
        const newNetTotal = newGrossEarningTotal - grossDeductionsTotal;
        setNetTotal(newNetTotal);
    }
    const handleEarnings = () => {
        if (selecttemp) {
            const notAllowedEarnings = [
                "basic",
                "house_rent_allowance",
                "conveyance_allowance",
                "medical_allowance",
                "education_allowance",
                "leave_travel_allowance",
                "employees_state_insurance_corporation",
                "employer_contribution_to_pf",
                "gratuity",
                "statutory_bonus",
                "overtime_pay",
                "special_allowance", // it is an adjustment component
                "variable_pay"
            ];
            if (custom_earning_data) {
                const filteredEarnings = (custom_earning_data?.[0]?.earnings_json || [])?.filter(earning =>
                    !notAllowedEarnings?.includes(earning?.name)
                );
                setEarningData({ load: false, values: filteredEarnings });
            }
        } else if (contractual || contractualPayableDays || contractualDaily) {
            const notAllowedEarnings = [
                "conveyance_allowance",
                "medical_allowance",
                "education_allowance",
                "leave_travel_allowance",
                "employees_state_insurance_corporation",
                "gratuity",
                "statutory_bonus",
                "employer_contribution_to_pf",
                "leave_wages",
                "ph_allowance",
                "overtime_pay",
            ];
            if (custom_earning_data) {
                const filteredEarnings = (custom_earning_data?.[0]?.earnings_json || [])?.filter(
                    earning => !notAllowedEarnings?.includes(earning?.name)
                );
                setEarningData({ load: false, values: filteredEarnings });
            }
        } else if (monthlyCtcTemplate) {
            const notAllowedEarnings = [
                "employees_state_insurance_corporation",
                "employer_contribution_to_pf",
                "gratuity",
                "statutory_bonus",
                "overtime_pay",

                //  "special_allowance", // in monthly it is not adjustment component
            ];
            if (custom_earning_data) {
                const filteredEarnings = (custom_earning_data?.[0]?.earnings_json || [])?.filter(
                    earning => !notAllowedEarnings?.includes(earning?.name)
                );
                setEarningData({ load: false, values: filteredEarnings });
            }
        }
        else {
            custom_earning_data &&
                setEarningData({ load: false, values: custom_earning_data?.[0]?.earnings_json });
        }
    };
    const getFilteredEarnings = (id) => {
        const selectedEarnings = templateEarningData?.map((item, index) => index !== id && item?.earning_key?.name)?.filter(Boolean);

        const hasFixedDA = selectedEarnings?.includes("fixed_dearness_allowance");
        const hasVariableDA = selectedEarnings?.includes("variable_dearness_allowance");

        return earningData?.values?.filter((option) => {
            // Filter out already selected earnings
            if (selectedEarnings?.includes(option.name)) return false;

            // DA: if one is selected, hide the other
            if (hasFixedDA && option?.name === "variable_dearness_allowance") return false;
            if (hasVariableDA && option?.name === "fixed_dearness_allowance") return false;

            return true;
        });
    };
    //Deduction Template Name Section
    const handleDeduction = () => {
        if (selecttemp || contractual || contractualDaily || contractualPayableDays || monthlyCtcTemplate) {
            const notAllowedDeductions = [
                "professional_tax",
                "standard_deduction",
                "employee_contribution_to_pf",
                "employees_state_insurance_corporation",
                "income_tax"
            ];
            if (custom_deduction_data) {
                const filteredDeductions = (custom_deduction_data?.[0]?.deductions_json || [])?.filter(deduction =>
                    !notAllowedDeductions?.includes(deduction?.name)
                );
                setDeductionData({ load: false, values: filteredDeductions });
            }
        } else {
            custom_deduction_data &&
                setDeductionData({ load: false, values: custom_deduction_data?.[0]?.deductions_json });
        }

    };
    const handleAddDeductionFields = () => {
        setTemplateDeductionData((state) => [...state, templateDeductionValues]);
    };
    const handleDeductionDelete = (e, id, deleteid) => {
        let Data = [...templateDeductionData];
        Data?.splice(id, 1);
        setTemplateDeductionData(Data);
        const newGrossDeductionTotal = Data?.reduce((total, item) => {
            return total + (parseFloat(item?.deduction_value) || 0); // Add the valid values
        }, 0);
        setGrossDeductionsTotal(newGrossDeductionTotal);
        const newNetTotal = grossEarningsTotal - newGrossDeductionTotal;
        setNetTotal(newNetTotal);
    };
    const Deductionvalidate = () => {
        let isValid = true;
        const newErrors = [...templateDeductionErrors];
        templateDeductionData?.forEach((store, index) => {
            const error = {};
            if (!store?.deduction_key) {
                error.deduction_key = "Name is required";
                isValid = false;
            }
            if (!store?.deduction_value) {
                error.deduction_value = "Value is required";
                isValid = false;
            }
            while (newErrors?.length <= index) {
                newErrors.push({});
            }
            newErrors[index] = error;
        });
        setTemplateDeductionErrors(newErrors);
        return isValid;
    };
    const handleDeductionChange = (e, value, id) => {
        let newArr = [...templateDeductionData];
        const newErrors = [...templateDeductionErrors];
        let item = newArr[id];
        item = { ...item, [e]: value };
        newArr[id] = item;
        newErrors[id] = { ...newErrors[id], [e]: "" };
        setTemplateDeductionData(newArr);
        setTemplateDeductionErrors(newErrors);
        const newGrossDeductionTotal = newArr?.reduce((total, item) => {
            return total + (parseFloat(item?.deduction_value) || 0);
        }, 0);
        setGrossDeductionsTotal(newGrossDeductionTotal);
        setNetTotal(grossEarningsTotal - newGrossDeductionTotal);
    }
    const getFilteredDeduction = (id) => {
        const selectedDeduction = templateDeductionData?.map((item, index) => index !== id && item?.deduction_key?.name)?.filter(Boolean);
        return deductionData?.values?.filter(
            (option) => !selectedDeduction?.includes(option.name)
        );
    };
    function sortTemplatesByNameAndDefault(data) {
        if (!Array.isArray(data) || data?.length === 0) {
            return [];
        }
        return data?.sort((a, b) => {
            if (a?.is_default !== b?.is_default) {
                return a?.is_default ? -1 : 1;
            }
            return a?.template_name?.localeCompare(b?.template_name);
        });
    }
    const handleTemplate = () => {
        payroll_template_data &&
            setTemplateData({ load: false, values: sortTemplatesByNameAndDefault(payroll_template_data) });
    };
    const handleInput = (event, value) => {
        const selectedTemplate = payroll_template_data?.find(t => t?.template_name === value?.template_name);
        setSelectTemp(selectedTemplate?.template_name === "Advanced Meepl Salary Template : Annual")
        setContractual(selectedTemplate?.template_name === "Contractual Template")
        setContractualDaily(selectedTemplate?.template_name === "Contractual Template : Daily Fixed");
        setContractualPayableDays(selectedTemplate?.template_name === "Contractual Template : Payable Days");
        setDailyWagesTemplate(selectedTemplate?.template_name === "Work-Based Pay");
        setMonthlyCtcTemplate(selectedTemplate?.template_name === "Advanced Meepl Salary Template : Monthly");
        if (["template_id"].includes(event)) {
            if (value) {
                setInputData({ ...inputData, [event]: value });
            } else {
                setInputData({ ...inputData, [event]: "" });
            }
        }
        if (selectedTemplate) {
            if (selectedTemplate?.template_name === "Meepl Salary Template" || selectedTemplate?.template_name === "Advanced Meepl Salary Template : Annual") {
                setDefaultTemplate(true);
                setVenilaTemplate(false);
                setTemplateEarningData([]);
                setTemplateDeductionData([]);

            } else if (selectedTemplate?.template_name === "Contractual Template" || selectedTemplate?.template_name === "Contractual Template : Daily Fixed" ||
                selectedTemplate?.template_name === "Contractual Template : Payable Days" || selectedTemplate?.template_name === "Advanced Meepl Salary Template : Monthly") {
                setVenilaTemplate(false);
                setDefaultTemplate(false);
                setTemplateEarningData(
                    selectedTemplate?.template_fields?.earning_key?.length > 0 ? selectedTemplate?.template_fields?.earning_key?.map(earning => ({
                        earning_key: {
                            name: earning?.name,
                            label: earning?.label
                        },
                        earning_value: "0",
                    })) : []
                );
                setTemplateDeductionData([]);
            } else if (selectedTemplate?.template_name === "Work-Based Pay") {
                setVenilaTemplate(false);
                setDefaultTemplate(false);
                setTemplateEarningData([]);
                setTemplateDeductionData([]);
            } else {
                setVenilaTemplate(true);
                setDefaultTemplate(false);
                setTemplateEarningData(
                    selectedTemplate?.template_fields?.earning_key?.length > 0 ? selectedTemplate?.template_fields?.earning_key?.map(earning => ({
                        earning_key: {
                            name: earning?.name,
                            label: earning?.label
                        },
                        earning_value: "0"
                    })) : []
                );
                setTemplateDeductionData(
                    selectedTemplate?.template_fields?.deduction_key?.length > 0 ? selectedTemplate?.template_fields?.deduction_key?.map(deduction => ({
                        deduction_key: { name: deduction?.name, label: deduction?.label },
                        deduction_value: "0"
                    })) : []
                );
                setGrossEarningsTotal(0);
                setGrossDeductionsTotal(0);
                setNetTotal(0)
            }
            setTemplate({
                ...initialValues
            });
            setOverTime({ overtime_applicable_flag: false, overtime_configuration_pk: "" })
        }
        setTempErrors({})
        setErrors({})
        setEsicInfo({ toggle: false, lastModified: null })
    }
    useEffect(() => {
        handleEarnings();
        handleDeduction();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selecttemp, contractual, contractualDaily, contractualPayableDays, monthlyCtcTemplate]);
    const validateTemplateName = (fieldValues) => {
        const templateExists = payroll_template_data?.some(template => template?.template_name === fieldValues?.template_name);
        if (templateExists) {
            toast.error("Template name is already taken", { duration: 2000, });
            return false;
        }
        return true;
    }
    const handleEdit = () => {
        setDisabled(false)
    }
    // Default Template Section
    const handleInputTemplate = (event, value) => {
        setTemplate({
            ...template,
            [event.target.name]: event.target.value,
        });
        Object.values?.(errors)?.find((res) => res !== "")?.length > 0 &&
            tempvalidate({
                ...template,
                [event.target.name]: event.target.value,
            });
        Object.values?.(temperrors)?.find((res) => res !== "")?.length > 0 &&
            tempvalidate({
                ...template,
                [event.target.name]: event.target.value,
            });
    };
    const tempvalidate = (fieldValues, overtime, skipFields = (contractual || contractualDaily || contractualPayableDays) ? ["ctc", "basic", "hra"] : []) => {
        let temp = { ...temperrors };
        if ("ctc" in fieldValues && !skipFields?.includes("ctc")) {
            temp.ctc = fieldValues.ctc === "" ? "CTC is required" : "";
        }
        if ("basic" in fieldValues && !skipFields?.includes("basic")) {
            temp.basic = fieldValues.basic === "" ? "Basic is required" : fieldValues.basic < 50 ? "Basic should be at least 50% of annual CTC." : "";
        }
        if ("hra" in fieldValues && !skipFields?.includes("hra")) {
            temp.hra = fieldValues.hra === "" ? "HRA is required" : "";
        }
        if ("conveyance_allowance" in fieldValues) {
            if (fieldValues?.conveyance_allowance_flag) {
                temp.conveyance_allowance = fieldValues.conveyance_allowance === "" ? "Conveyance Allowance is required" : "";
            }
            else {
                temp.conveyance_allowance = "";
            }
        }
        if ("medical_allowance" in fieldValues) {
            if (fieldValues?.medical_allowance_flag) {
                temp.medical_allowance = fieldValues.medical_allowance === "" ? "Medical Allowance is required" : "";
            }
            else {
                temp.medical_allowance = "";
            }
        }
        if ("educational_allowance" in fieldValues) {
            if (fieldValues?.educational_allowance_flag) {
                temp.educational_allowance = fieldValues.educational_allowance === "" ? "Educational Allowance is required" : "";
            }
            else {
                temp.educational_allowance = "";
            }
        }
        if ("lta" in fieldValues) {
            if (fieldValues?.lta_flag) {
                temp.lta = fieldValues.lta === "" ? "LTA is required" : "";
            }
            else {
                temp.lta = "";
            }
        }
        if ("pf_limit_amount" in fieldValues) {
            if ((fieldValues?.pf) && (fieldValues?.pf_limit_applicable)) {
                temp.pf_limit_amount = fieldValues.pf_limit_amount === "" ? "Amount required" : "";
                if (fieldValues.pf_limit_amount === "") {
                    temp.pf_limit_amount = "Amount required";
                } else if (fieldValues.pf_limit_amount > 25000) {
                    temp.pf_limit_amount = "Limit: ₹25,000";
                } else {
                    temp.pf_limit_amount = "";
                }
            }
            else {
                temp.pf_limit_amount = "";
            }
        }
        if (overtime?.overtime_applicable_flag) {
            if (!overtime?.overtime_configuration_pk) {
                temp.overtime_configuration_pk = "Overtime Code is required"
            }
            else {
                temp.overtime_configuration_pk = "";
            }
        }
        setTempErrors({
            ...temp,
        });
        return Object.values(temp).every((x) => x === "");
    };
    const [duplicateError, setDuplicateError] = useState({
        transport_applicable: "",
        food_applicable: ""
    });

    // validate if templateEarningData or templateDeductionData has the variable like Transport Allowance, Food Allowance already then the bottom checkboxes for both are also enabled then show alert, already selected in as variable.....
    const validateDuplicateVariables = () => {
        const hasTransportInEarnings = templateEarningData?.some(
            item => item?.earning_key?.name === "transport_allowance"
        );

        const hasFoodInEarnings = templateEarningData?.some(
            item => item?.earning_key?.name === "food"
        );
        const hasTransortInDeductions = templateDeductionData?.some(
            item => item?.deduction_key?.name === "transport_allowance"
        );
        const hasFoodInDeductions = templateDeductionData?.some(
            item => item?.deduction_key?.name === "food"
        );

        let errors = {};
        let isValid = true;

        if (hasTransportInEarnings && template?.transport_applicable) {
            errors.transport_applicable = "Transport Allowance is already added under earnings.";
            isValid = false;
        } else if (hasTransortInDeductions && template?.transport_applicable) {
            errors.transport_applicable = "Transport Allowance is already added under deductions.";
            isValid = false;
        } else {
            errors.transport_applicable = "";
        }

        if (hasFoodInEarnings && template?.food_applicable) {
            errors.food_applicable = "Food Allowance is already added under earnings.";
            isValid = false;
        } else if (hasFoodInDeductions && template?.food_applicable) {
            errors.food_applicable = "Food Allowance is already added under deductions.";
            isValid = false;
        } else {
            errors.food_applicable = "";
        }

        setDuplicateError(prev => ({
            ...prev,
            ...errors
        }));

        return isValid;
    };
    const getEarningFormattedData = () =>
        templateEarningData?.map((item) => ({
            name: item.earning_key?.name,
            label: item.earning_key?.label,
            value: item.earning_value,
        }));

    const getDeductionFormattedData = () =>
        templateDeductionData?.map((item) => ({
            name: item.deduction_key?.name,
            label: item.deduction_key?.label,
            value: item.deduction_value,
        }));

    const getFormattedDataToSend = () => {
        const data = getEarningFormattedData();
        return data?.length ? data : null;
    };

    const getFormattedDeductDataToSend = () => {
        const data = getDeductionFormattedData();
        return data?.length ? data : null;
    };
    const handleNext = () => {
        const isEarningsValid = Earningvalidate();
        const isDeductionsValid = Deductionvalidate();
        const skipFields = (contractual || contractualDaily || contractualPayableDays || monthlyCtcTemplate) ? ["ctc", "basic", "hra"] : [];
        if (tempvalidate(template, overtime, skipFields) && isEarningsValid && isDeductionsValid && validateDuplicateVariables()) {
            setIsSending(true);
            const formattedDataToSend = getFormattedDataToSend();
            const formattedDeductDataToSend = getFormattedDeductDataToSend();
            if (selecttemp) {
                CalculateEmployeeAdvanceSalaryTemplateHelper({ // Advanced Meepl Salary Template : Annual
                    ...template,
                    earning_component_json: formattedDataToSend ? JSON.stringify(formattedDataToSend) : null,
                    deduction_component_json: formattedDeductDataToSend ? JSON.stringify(formattedDeductDataToSend) : null,
                    pf_variable_components: null,
                    employee_id: currentData?.employee_id,
                }).then((res) => {
                    if (res?.data?.statuscode === 200) {
                        setIsSending(false);
                        setResData(res?.data?.data?.[0]);
                        setStep(2);
                    }
                    else {
                        setIsSending(false);
                        toast.error(`Something went wrong`, { duration: 2000, });
                    }
                });
            } else if (contractual) {
                CalculateEmployeeContractualSalaryTemplateHelper({
                    ...template,
                    earning_component_json: formattedDataToSend ? JSON.stringify(formattedDataToSend) : null,
                    deduction_component_json: formattedDeductDataToSend ? JSON.stringify(formattedDeductDataToSend) : null,
                    pf_variable_components: null,
                    employee_id: currentData?.employee_id,
                }).then((res) => {
                    if (res?.data?.statuscode === 200) {
                        setIsSending(false);
                        setResData(res?.data?.data?.[0]);
                        setStep(2);
                    }
                    else {
                        setIsSending(false);
                        toast.error(`Something went wrong`, { duration: 2000, });
                    }
                });
            } else if (contractualDaily) {
                CalculateEmployeeContractualDailySalaryTemplateHelper({
                    ...template,
                    earning_component_json: formattedDataToSend ? JSON.stringify(formattedDataToSend) : null,
                    deduction_component_json: formattedDeductDataToSend ? JSON.stringify(formattedDeductDataToSend) : null,
                    pf_variable_components: null,
                    employee_id: currentData?.employee_id,
                }).then((res) => {
                    if (res?.data?.statuscode === 200) {
                        setIsSending(false);
                        setResData(res?.data?.data?.[0]);
                        setStep(2);
                    }
                    else {
                        setIsSending(false);
                        toast.error(`Something went wrong`, { duration: 2000 });
                    }
                });
            } else if (contractualPayableDays) {
                CalculateContractualPayableDaysSalaryTemplateHelper({
                    ...template,
                    earning_component_json: formattedDataToSend ? JSON.stringify(formattedDataToSend) : null,
                    deduction_component_json: formattedDeductDataToSend ? JSON.stringify(formattedDeductDataToSend) : null,
                    pf_variable_components: null,
                    employee_id: currentData?.employee_id,
                }).then((res) => {
                    if (res?.data?.statuscode === 200) {
                        setIsSending(false);
                        setResData(res?.data?.data?.[0]);
                        setStep(2);
                    }
                    else {
                        setIsSending(false);
                        toast.error(`Something went wrong`, { duration: 2000 });
                    }
                });
            } else if (monthlyCtcTemplate) {
                CalculateMonthlyCtcTemplateHelper({ // Advanced Meepl Salary Template : Monthly
                    ...template,
                    ctc: 12 * monthlyCtcAutoTotalCalc,
                    earning_component_json: formattedDataToSend ? JSON.stringify(formattedDataToSend) : null,
                    deduction_component_json: formattedDeductDataToSend ? JSON.stringify(formattedDeductDataToSend) : null,
                    pf_variable_components: null,
                    employee_id: currentData?.employee_id,
                }).then((res) => {
                    if (res?.data?.statuscode === 200) {
                        setIsSending(false);
                        setResData(res?.data?.data?.[0]);
                        setStep(2);
                    }
                    else {
                        setIsSending(false);
                        toast.error(`Something went wrong`, { duration: 2000, });
                    }
                });
            } else {
                CalculateEmployeeSalaryTemplateHelper({ // Meepl Salary Template
                    ...template,
                    pf_variable_components: null,
                    employee_id: currentData?.employee_id,
                }).then((res) => {
                    if (res?.data?.statuscode === 200) {
                        setIsSending(false);
                        setResData(res?.data?.data?.[0]);
                        setStep(2);
                    }
                    else {
                        setIsSending(false);
                        toast.error(`Something went wrong`, { duration: 2000, });
                    }
                });
            }

        }
    }
    const handleSubmitTemp = () => {
        if (selecttemp) {
            AddCalculateEmployeeAdvanceSalaryTemplateHelper({
                ...resData,
                ctc: (grossEarningsTempTotal * 12).toString(),
                conveyance_allowance_flag: template?.conveyance_allowance_flag,
                medical_allowance_flag: template?.medical_allowance_flag,
                educational_allowance_flag: template?.educational_allowance_flag,
                lta_flag: template?.lta_flag,
                employee_id: currentData?.employee_id,
                overtime_applicable_flag: overtime?.overtime_applicable_flag,
                pf_flag: template?.pf,
                pf_limit_applicable_flag: template?.pf_limit_applicable,
                eps_applicable_flag: template?.eps_applicable_flag,
                pf_limit_amount: template?.pf_limit_amount,
                earning_component_json: JSON.stringify(resData?.earning_component_json),
                payroll_onhold: template?.payroll_onhold,
                deduction_component_json: JSON.stringify(resData?.deduction_component_json),
                pf_variable_components: null,
                pf_earnings_applicable: template?.pf_earnings_applicable,
                overtime_configuration_pk: overtime?.overtime_applicable_flag ? overtime?.overtime_configuration_pk?.overtime_configuration_pk : null,
                transport_applicable: template?.transport_applicable,
                transport_earnings: template?.transport_earnings,
                transport_deductions: template?.transport_deductions,
                food_applicable: template?.food_applicable,
                food_earnings: template?.food_earnings,
                food_deductions: template?.food_deductions,
                statutory_bonus_flag: template?.statutory_bonus_flag,
                gratuity_flag: template?.gratuity_flag,
                pf_compliant_flag: template?.pf_compliant_flag,
                weekoff_caln_applicable: template?.weekoff_caln_applicable,
                monthly_working_hrs_calc: template?.monthly_working_hrs_calc
            }).then((res) => {
                if (res?.data?.statuscode === 200) {
                    setIsSending(false);
                    callDependencyFetch();
                }
            });
        } else if (contractual) {
            AddCalculateEmployeeContractualSalaryTemplateHelper({
                ...resData,
                conveyance_allowance_flag: template?.conveyance_allowance_flag,
                medical_allowance_flag: template?.medical_allowance_flag,
                educational_allowance_flag: template?.educational_allowance_flag,
                lta_flag: template?.lta_flag,
                employee_id: currentData?.employee_id,
                overtime_applicable_flag: overtime?.overtime_applicable_flag,
                pf_flag: template?.pf,
                pf_limit_applicable_flag: template?.pf_limit_applicable,
                eps_applicable_flag: template?.eps_applicable_flag,
                pf_limit_amount: template?.pf_limit_amount,
                earning_component_json: JSON.stringify(resData?.earning_component_json),
                payroll_onhold: template?.payroll_onhold,
                deduction_component_json: JSON.stringify(resData?.deduction_component_json),
                pf_variable_components: null,
                pf_earnings_applicable: template?.pf_earnings_applicable,
                overtime_configuration_pk: overtime?.overtime_applicable_flag ? overtime?.overtime_configuration_pk?.overtime_configuration_pk : null,
                leave_wages_applicable: template?.leave_wages_applicable,
                transport_applicable: template?.transport_applicable,
                transport_earnings: template?.transport_earnings,
                transport_deductions: template?.transport_deductions,
                ph_wages_applicable: template?.ph_wages_applicable,
                food_applicable: template?.food_applicable,
                food_earnings: template?.food_earnings,
                food_deductions: template?.food_deductions,
                weekoff_caln_applicable: template?.weekoff_caln_applicable ?? true,
                statutory_bonus_flag: template?.statutory_bonus_flag,
                pf_compliant_flag: template?.pf_compliant_flag,
                monthly_working_hrs_calc: template?.monthly_working_hrs_calc
            }).then((res) => {
                if (res?.data?.statuscode === 200) {
                    setIsSending(false);
                    callDependencyFetch();
                }
            });
        } else if (contractualDaily) {
            AddCalculateEmployeeContractualDailySalaryTemplateHelper({
                ...resData,
                conveyance_allowance_flag: template?.conveyance_allowance_flag,
                medical_allowance_flag: template?.medical_allowance_flag,
                educational_allowance_flag: template?.educational_allowance_flag,
                lta_flag: template?.lta_flag,
                employee_id: currentData?.employee_id,
                overtime_applicable_flag: overtime?.overtime_applicable_flag,
                pf_flag: template?.pf,
                pf_limit_applicable_flag: template?.pf_limit_applicable,
                eps_applicable_flag: template?.eps_applicable_flag,
                pf_limit_amount: template?.pf_limit_amount,
                earning_component_json: JSON.stringify(resData?.earning_component_json),
                payroll_onhold: template?.payroll_onhold,
                deduction_component_json: JSON.stringify(resData?.deduction_component_json),
                pf_variable_components: null,
                pf_earnings_applicable: template?.pf_earnings_applicable,
                overtime_configuration_pk: overtime?.overtime_applicable_flag ? overtime?.overtime_configuration_pk?.overtime_configuration_pk : null,
                leave_wages_applicable: template?.leave_wages_applicable,
                transport_applicable: template?.transport_applicable,
                transport_earnings: template?.transport_earnings,
                transport_deductions: template?.transport_deductions,
                ph_wages_applicable: template?.ph_wages_applicable,
                food_applicable: template?.food_applicable,
                food_earnings: template?.food_earnings,
                food_deductions: template?.food_deductions,
                weekoff_caln_applicable: template?.weekoff_caln_applicable ?? true,
                statutory_bonus_flag: template?.statutory_bonus_flag,
                pf_compliant_flag: template?.pf_compliant_flag,
                monthly_working_hrs_calc: template?.monthly_working_hrs_calc,
            }).then((res) => {
                if (res?.data?.statuscode === 200) {
                    setIsSending(false);
                    callDependencyFetch();
                }
            });
        } else if (contractualPayableDays) {
            AddCalculateContractualPayableDaysSalaryTemplateHelper({
                ...resData,
                conveyance_allowance_flag: template?.conveyance_allowance_flag,
                medical_allowance_flag: template?.medical_allowance_flag,
                educational_allowance_flag: template?.educational_allowance_flag,
                lta_flag: template?.lta_flag,
                employee_id: currentData?.employee_id,
                overtime_applicable_flag: overtime?.overtime_applicable_flag,
                pf_flag: template?.pf,
                pf_limit_applicable_flag: template?.pf_limit_applicable,
                eps_applicable_flag: template?.eps_applicable_flag,
                pf_limit_amount: template?.pf_limit_amount,
                earning_component_json: JSON.stringify(resData?.earning_component_json),
                payroll_onhold: template?.payroll_onhold,
                deduction_component_json: JSON.stringify(resData?.deduction_component_json),
                pf_variable_components: null,
                pf_earnings_applicable: template?.pf_earnings_applicable,
                overtime_configuration_pk: overtime?.overtime_applicable_flag ? overtime?.overtime_configuration_pk?.overtime_configuration_pk : null,
                leave_wages_applicable: template?.leave_wages_applicable,
                transport_applicable: template?.transport_applicable,
                transport_earnings: template?.transport_earnings,
                transport_deductions: template?.transport_deductions,
                ph_wages_applicable: template?.ph_wages_applicable,
                food_applicable: template?.food_applicable,
                food_earnings: template?.food_earnings,
                food_deductions: template?.food_deductions,
                weekoff_caln_applicable: template?.weekoff_caln_applicable ?? true,
                statutory_bonus_flag: template?.statutory_bonus_flag,
                pf_compliant_flag: template?.pf_compliant_flag,
                monthly_working_hrs_calc: template?.monthly_working_hrs_calc
            }).then((res) => {
                if (res?.data?.statuscode === 200) {
                    setIsSending(false);
                    callDependencyFetch();
                }
            });
        } else if (dailyWagesTemplate) {
            if (!validate(template)) return;
            setIsSending(true)
            UpdateDailyWageTemplateHelper({
                employee_fk: currentData?.employee_id,
                daily_wage_per_hr_amount: template?.daily_wage_per_hr_amount
            }).then((res) => {
                if (res?.data?.statuscode === 200) {
                    setIsSending(false);
                    callDependencyFetch();
                }
            });
        } else if (monthlyCtcTemplate) {
            AddCalculatemonthlyCtcTemplateHelper({
                ...resData,
                ctc: (grossEarningsTempTotal * 12).toString(),
                employee_id: currentData?.employee_id,
                overtime_applicable_flag: overtime?.overtime_applicable_flag,
                pf_flag: template?.pf,
                pf_limit_applicable_flag: template?.pf_limit_applicable,
                eps_applicable_flag: template?.eps_applicable_flag,
                pf_limit_amount: template?.pf_limit_amount,
                earning_component_json: JSON.stringify(resData?.earning_component_json),
                payroll_onhold: template?.payroll_onhold,
                deduction_component_json: JSON.stringify(resData?.deduction_component_json),
                pf_variable_components: null,
                pf_earnings_applicable: template?.pf_earnings_applicable,
                overtime_configuration_pk: overtime?.overtime_applicable_flag ? overtime?.overtime_configuration_pk?.overtime_configuration_pk : null,
                transport_applicable: template?.transport_applicable,
                transport_earnings: template?.transport_earnings,
                transport_deductions: template?.transport_deductions,
                food_applicable: template?.food_applicable,
                food_earnings: template?.food_earnings,
                food_deductions: template?.food_deductions,
                statutory_bonus_flag: template?.statutory_bonus_flag,
                gratuity_flag: template?.gratuity_flag,
                pf_compliant_flag: template?.pf_compliant_flag,
                weekoff_caln_applicable: template?.weekoff_caln_applicable,
                monthly_working_hrs_calc: template?.monthly_working_hrs_calc
            }).then((res) => {
                if (res?.data?.statuscode === 200) {
                    setIsSending(false);
                    callDependencyFetch();
                }
            });
        } else {
            AddCalculateEmployeeSalaryTemplateHelper({
                ...resData,
                ctc: (grossEarningsTempTotal * 12).toString(),
                conveyance_allowance_flag: template?.conveyance_allowance_flag,
                medical_allowance_flag: template?.medical_allowance_flag,
                educational_allowance_flag: template?.educational_allowance_flag,
                lta_flag: template?.lta_flag,
                employee_id: currentData?.employee_id,
                overtime_applicable_flag: overtime?.overtime_applicable_flag,
                payroll_onhold: template?.payroll_onhold,
                pf_flag: template?.pf,
                pf_limit_applicable_flag: template?.pf_limit_applicable,
                eps_applicable_flag: template?.eps_applicable_flag,
                pf_limit_amount: template?.pf_limit_amount,
                pf_earnings_applicable: template?.pf_earnings_applicable,
                pf_variable_components: null,
                overtime_configuration_pk: overtime?.overtime_configuration_pk?.overtime_configuration_pk,
                transport_applicable: template?.transport_applicable,
                transport_earnings: template?.transport_earnings,
                transport_deductions: template?.transport_deductions,
                food_applicable: template?.food_applicable,
                food_earnings: template?.food_earnings,
                food_deductions: template?.food_deductions,
                statutory_bonus_flag: template?.statutory_bonus_flag,
                gratuity_flag: template?.gratuity_flag,
                pf_compliant_flag: template?.pf_compliant_flag,
                weekoff_caln_applicable: template?.weekoff_caln_applicable,
                monthly_working_hrs_calc: template?.monthly_working_hrs_calc
            }).then((res) => {
                if (res?.data?.statuscode === 200) {
                    setIsSending(false);
                    callDependencyFetch();
                }
            });
        }

        setOpenTemplate(false);
        if (createEmp) {
            setOpenPopup(false);
            setSuccessPopup(false)
        }
        else if (isonboard) {
            setCurrentMode("grid");
            setInternal(true)
        }
    }

    const handleOnhold = () => {

        onholdEmployeeHelper({
            employee_id: currentData?.employee_id,
            payroll_onhold: template?.payroll_onhold
        }).then((res) => {
            if (res?.data?.statuscode === 200) {
                let successFlag = res?.data?.data?.[0]?.fn_update_onhold_payroll_flag
                setOnHold(false);
                setOpenTemplate(false);
                if (successFlag === true) {
                    toast.success(`${currentData?.name}'s salary is now on hold.`, { duration: 2000, });
                }
                else {
                    toast.success(`${currentData?.name}'s salary is now active.`, { duration: 2000, });
                }
                callDependencyFetch();
            }
        });
    }

    const handleCancel = () => {
        setOnHold(false);
        setTemplate({
            ...template,
            payroll_onhold: currentData?.payroll_onhold
        })
    }

    const handleOvertimeOptions = () => {
        GetOverTimeHelper().then((res) => {
            if (res?.data?.statuscode === 200) {
                setOvertimeOptionData({ load: false, values: res?.data?.data });
            }
        })
    }

    const handleOverTimeChange = (event, value) => {
        if (["overtime_configuration_pk"].includes(event)) {
            if (value) {
                setOverTime({ ...overtime, [event]: value });
                Object.values?.(temperrors)?.find((res) => res !== "")?.length > 0 &&
                    tempvalidate(
                        {},
                        { ...overtime, [event]: value });
            } else {
                setOverTime({ ...overtime, [event]: "" });
            }
        }
    }

    return (
        <>
            {(isLoading2 || isLoading) ? (
                <Box sx={{ width: '100%', marginTop: 2 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <Box>
                                <Skeleton variant="text" width="60%" height={30} sx={{ marginBottom: 1 }} />
                                <Skeleton variant="text" width="80%" height={20} sx={{ marginBottom: 2 }} />
                                <Skeleton variant="rectangular" width="100%" height={300} />
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Box>
                                <Skeleton variant="text" width="60%" height={30} sx={{ marginBottom: 1 }} />
                                <Skeleton variant="text" width="80%" height={20} sx={{ marginBottom: 2 }} />
                                <Skeleton variant="rectangular" width="100%" height={300} />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            ) : (
                <>
                    <Grid container>
                        <Grid
                            item
                            xs={12}
                            md={8}
                            sx={{
                                px: "15px",
                                pointerEvents: currentData?.payroll_onhold ? "none" : "auto",
                                opacity: currentData?.payroll_onhold ? 0.6 : 1,
                            }}
                        >
                            {(payroll_template_data?.length > 0 && !disabled) && (
                                <FormControl fullWidth>
                                    <SelectableSearch
                                        isOptionEqualToValue={(option, value) =>
                                            +option?.template_id === +value?.template_id
                                        }
                                        label="Select from Saved Templates"
                                        fullWidth
                                        disabled={disabled || step === 2}
                                        value={inputData?.template_id}
                                        loading={() => handleTemplate()}
                                        fieldLabel="template_name"
                                        required={false}
                                        grouping={true}
                                        groupByFn={(option) => option.is_default ? "Meepl Templates" : "Custom Templates"}
                                        variantType={"standard"}
                                        name="template_id"
                                        size="small"
                                        onChangeEvent={handleInput}
                                        data={templateData}
                                    />
                                </FormControl>
                            )}
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={4}
                            sx={{
                                px: "15px",
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center"
                            }}
                        >
                            {employee_template_data?.length > 0 && (step !== 2) && (
                                <EditIcon
                                    onClick={(e) => handleEdit(e)}
                                    sx={{
                                        margin: "15px 5px 0px 15px", cursor: "pointer", pointerEvents: currentData?.payroll_onhold ? "none" : "auto",
                                        opacity: currentData?.payroll_onhold ? 0.6 : 1,
                                    }}
                                    fontSize="small"
                                />
                            )}
                            {!dailyWagesTemplate && <div>
                                <FormGroup>
                                    <FormControlLabel sx={{ margin: "15px 0px 0px 0px", cursor: "pointer" }}
                                        control={
                                            <Switch
                                                onChange={() => handleToggleOnHold("payroll_onhold")}
                                                checked={template?.payroll_onhold}
                                            />
                                        }
                                        label="Hold Salary"
                                    />
                                </FormGroup>
                            </div>}
                        </Grid>
                        {activeMessage && (
                            <Grid
                                item
                                xs={12}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    pl: "15px",
                                }}
                            >
                                <Typography variant="body2">
                                    {activeMessage?.text}
                                    {activeMessage?.tooltip && (
                                        <LightTooltip title={activeMessage.tooltip}>
                                            <InfoOutlinedIcon
                                                fontSize="small"
                                                color="action"
                                                sx={{ ml: 0.5, verticalAlign: "middle", cursor: "pointer" }}
                                            />
                                        </LightTooltip>)}
                                </Typography>
                            </Grid>
                        )}
                    </Grid>
                    <Box
                        sx={{
                            pointerEvents: currentData?.payroll_onhold ? "none" : "auto",
                            opacity: currentData?.payroll_onhold ? 0.6 : 1,
                        }}
                    >
                        {dailyWagesTemplate && (
                            <>
                            <Grid
                                item
                                xs={12}
                                md={8}
                                sx={{

                                    p: "15px",
                                    pointerEvents: currentData?.payroll_onhold ? "none" : "auto",
                                    opacity: currentData?.payroll_onhold ? 0.6 : 1,
                                }}
                            >
                                <Grid container alignItems="center">
                                    <Grid item xs={5}>
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                fontWeight: 500,
                                                color: "text.primary",
                                            }}
                                        >
                                            Per hour amount*
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={7}>
                                        <TextField
                                            size="small"
                                            required
                                            value={template.daily_wage_per_hr_amount}
                                            onChange={(e) => {
                                            const val = e.target.value;
                                            if (val === "" || (Number(val) >= 0 )) {
                                                handleInputChange1(e);
                                            }
                                            }}
                                            variant="standard"
                                            type="number"
                                            fullWidth
                                            disabled={disabled}
                                            id="daily_wage_per_hr_amount"
                                            name="daily_wage_per_hr_amount"
                                            inputProps={{
                                                inputMode: "decimal",
                                                pattern: "[0-9]*",
                                                step: "0.01",
                                            }}
                                            {...(errors.daily_wage_per_hr_amount && {
                                                error: true,
                                                helperText:
                                                    errors.daily_wage_per_hr_amount,
                                            })}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                                <Box sx={{ border: "1px solid #ccc", borderRadius: 2, p: 2, backgroundColor: "#f9f9f9", mt: 2, mb: 2 }}>
                                    <Typography
                                        variant="subtitle1"
                                        sx={{
                                            fontWeight: 500,
                                            color: "#333",
                                        }}
                                    >
                                        This setup will be considered fully complete for the pay period once all daily wages data is available in{' '}
                                        <Typography component="span" sx={{ fontWeight: 600 }}>
                                            Work-Based Pay
                                        </Typography>
                                        .
                                    </Typography>
                                </Box>
                                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                                    <Button disabled={isSending} onClick={handleSubmitTemp} size="small" variant="outlined">
                                        Submit
                                    </Button>
                                </Box>
                            </>
                        )}
                        {venilatemplate && (
                            <Box>
                                <Grid container>
                                    <Grid
                                        item
                                        xs={12}
                                        md={6}
                                        sx={{
                                            marginTop: "1rem",
                                            px: "15px",
                                        }}
                                    >
                                        <Box sx={{
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "space-between"
                                        }}>
                                            {/* /// Vanilla */}
                                            <Typography
                                                variant="h6"
                                                gutterBottom
                                            >
                                                Earnings
                                            </Typography>
                                            <Tooltip title="Add">
                                                <IconButton
                                                    disabled={disabledEarningTemplate || disabled}
                                                    className="mpl-primary-btn"
                                                    onClick={handleAddEarningFields}
                                                    style={{ padding: '4px', minWidth: '30px', height: '30px' }}
                                                >
                                                    <AddIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        md={6}
                                        sx={{
                                            marginTop: "1rem",
                                            px: "15px",
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            gutterBottom
                                        >
                                            Monthly
                                        </Typography>
                                    </Grid>
                                </Grid>
                                {templateEarningData?.map((res, id) => {
                                    return (
                                        <>
                                            <Grid container>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    md={6}
                                                    sx={{
                                                        marginTop: "1rem",
                                                        px: "15px",
                                                    }}
                                                >
                                                    <FormControl fullWidth>
                                                        <SelectableSearch
                                                            isOptionEqualToValue={(option, value) =>
                                                                option?.label === value?.name
                                                            }
                                                            label="Select an Earnings"
                                                            fullWidth
                                                            disabled={disabled}
                                                            value={res?.earning_key}
                                                            loading={() => handleEarnings()}
                                                            fieldLabel="label"
                                                            required={false}
                                                            variantType={"standard"}
                                                            name="earning_key"
                                                            size="small"
                                                            onChangeEvent={(e, newValue) =>
                                                                handleEarningChange("earning_key", newValue, id)
                                                            }
                                                            data={{ load: earningData.load, values: getFilteredEarnings(id) }}
                                                            {...(templateEarningErrors[id] &&
                                                                templateEarningErrors[id].earning_key && {
                                                                error: true,
                                                                helperText: templateEarningErrors[id].earning_key,
                                                            })}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    md={6}
                                                    sx={{
                                                        marginTop: "32px",
                                                        px: "15px",
                                                    }}
                                                >
                                                    <FormControl fullWidth>
                                                        <TextField
                                                            size="small"
                                                            required
                                                            value={res.earning_value}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                if (/^\d*\.?\d*$/.test(value)) {
                                                                    handleEarningChange(e.target.name, value, id);
                                                                }
                                                            }}
                                                            variant={"standard"}
                                                            fullWidth
                                                            disabled={disabled}
                                                            id="earning_value"
                                                            label=""
                                                            name="earning_value"
                                                            autoComplete="earning_value"
                                                            inputProps={{
                                                                inputMode: 'decimal',
                                                                pattern: "[0-9]*",
                                                                step: "0.01"
                                                            }}
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        {!disabled && (
                                                                            <DeleteIcon
                                                                                color="error"
                                                                                onClick={(e) => handleEarningDelete(e, id, res?.certificate_id)}
                                                                                fontSize="small"
                                                                                sx={{ cursor: "pointer", marginLeft: 1 }}
                                                                            />
                                                                        )}
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                            {...(templateEarningErrors[id] &&
                                                                templateEarningErrors[id].earning_value && {
                                                                error: true,
                                                                helperText: templateEarningErrors[id].earning_value,
                                                            })}
                                                        />
                                                    </FormControl>
                                                </Grid>

                                            </Grid>
                                        </>
                                    );
                                })}
                                <Divider sx={{ mt: 2 }} />
                                <Grid container>
                                    <Grid
                                        item
                                        xs={12}
                                        md={6}
                                        sx={{
                                            marginTop: "1rem",
                                            px: "15px",
                                        }}
                                    >
                                        <Box sx={{
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "space-between",
                                        }}>
                                            <Typography
                                                variant="h6"
                                                gutterBottom
                                            >
                                                Deduction
                                            </Typography>
                                            <Tooltip title="Add">
                                                <IconButton
                                                    disabled={disabledDeductionTemplate || disabled}
                                                    className="mpl-primary-btn"
                                                    style={{ padding: '4px', minWidth: '30px', height: '30px' }}
                                                    onClick={handleAddDeductionFields}
                                                >
                                                    <AddIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        md={6}
                                        sx={{
                                            marginTop: "1rem",
                                            px: "15px",
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            gutterBottom
                                        >
                                            Monthly
                                        </Typography>
                                    </Grid>
                                </Grid>
                                {templateDeductionData?.map((res, id) => {
                                    return (
                                        <>
                                            <Grid container>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    md={6}
                                                    sx={{
                                                        marginTop: "1rem",
                                                        px: "15px",
                                                    }}
                                                >
                                                    <FormControl fullWidth>
                                                        <SelectableSearch
                                                            isOptionEqualToValue={(option, value) =>
                                                                option?.name === value?.name
                                                            }
                                                            label="Select an Deductions"
                                                            fullWidth
                                                            disabled={disabled}
                                                            value={res?.deduction_key}
                                                            loading={() => handleDeduction()}
                                                            fieldLabel="label"
                                                            required={false}
                                                            variantType={"standard"}
                                                            name="deduction_key"
                                                            size="small"
                                                            onChangeEvent={(e, newValue) =>
                                                                handleDeductionChange("deduction_key", newValue, id)
                                                            }
                                                            data={{ load: deductionData.load, values: getFilteredDeduction(id) }}
                                                            {...(templateDeductionErrors[id] &&
                                                                templateDeductionErrors[id].deduction_key && {
                                                                error: true,
                                                                helperText: templateDeductionErrors[id].deduction_key,
                                                            })}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    md={6}
                                                    sx={{
                                                        marginTop: "32px",
                                                        px: "15px",
                                                    }}
                                                >
                                                    <FormControl fullWidth>
                                                        <TextField
                                                            size="small"
                                                            required
                                                            value={res.deduction_value}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                if (/^\d*\.?\d*$/.test(value)) {
                                                                    handleDeductionChange(e.target.name, value, id);
                                                                }
                                                            }}
                                                            variant={"standard"}
                                                            fullWidth
                                                            id="deduction_value"
                                                            disabled={disabled}
                                                            label=""
                                                            name="deduction_value"
                                                            autoComplete="deduction_value"
                                                            inputProps={{
                                                                inputMode: 'decimal',
                                                                pattern: "[0-9]*",
                                                                step: "0.01"
                                                            }}
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        {!disabled && (
                                                                            <DeleteIcon
                                                                                color="error"
                                                                                onClick={(e) => handleDeductionDelete(e, id, res?.certificate_id)}
                                                                                fontSize="small"
                                                                                sx={{ cursor: "pointer", marginLeft: 1 }}
                                                                            />
                                                                        )}
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                            {...(templateDeductionErrors[id] &&
                                                                templateDeductionErrors[id].deduction_value && {
                                                                error: true,
                                                                helperText: templateDeductionErrors[id].deduction_value,
                                                            })}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </>
                                    );
                                })}
                                <Box sx={{ marginTop: "1rem" }}>
                                    <OvertimeSelector
                                        disabled={disabled}
                                        overtime={overtime}
                                        handleInputChange={handleInputChange1}
                                        handleOvertimeOptions={handleOvertimeOptions}
                                        handleOverTimeChange={handleOverTimeChange}
                                        overtimeOptionData={overtimeOptionData}
                                        temperrors={temperrors}
                                    />
                                </Box>
                                <Grid container>
                                    <Grid
                                        item
                                        xs={12}
                                        md={6}
                                        sx={{
                                            marginTop: "1rem",
                                            px: "15px"
                                        }}
                                    ></Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        md={6}
                                        sx={{
                                            marginTop: "1rem",
                                            px: "10px",
                                        }}
                                    >
                                        <div className={classes.row}>
                                            <span className={classes.label}> Gross Earning Total </span>
                                            <div className={classes.value}>: &nbsp; {formatNumber(grossEarningsTotal) || 0}</div>
                                        </div>
                                        <div className={classes.row}>
                                            <span className={classes.label}>  Gross Deduction Total &nbsp;</span>
                                            <div className={classes.value}>: &nbsp;  {formatNumber(grossDeductionsTotal) || 0}</div>
                                        </div>
                                        <Divider sx={{ mt: 2 }} />
                                        <div className={classes.row}>
                                            <span className={classes.netlabel}> Net Total </span>
                                            <div className={classes.value}>: &nbsp;  {formatNumber(netTotal) || 0}</div>
                                        </div>
                                    </Grid>
                                </Grid>
                                <>

                                    <Box sx={{
                                        width: "100%",
                                        mt: 3,
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    disabled={netTotal <= 0 || disabled}
                                                    name="save_as_template"
                                                    checked={templatename?.save_as_template || false}
                                                    onChange={handleInputChange}
                                                />
                                            }
                                            label="Save as Template"
                                        />
                                        {/* // vanilaa template */}
                                        <Tooltip title={netTotal === 0 ? "Net total is zero. Please review earnings and deductions." : netTotal < 0 ? "Net total is negative. Please review earnings and deductions." : ""}
                                            placement="top">
                                            <Box>
                                                <Button disabled={netTotal <= 0 || disabled || isSending} onClick={handleSubmit} size="small" variant="outlined">
                                                    Submit
                                                </Button>
                                            </Box>
                                        </Tooltip>
                                    </Box>
                                </>
                            </Box>
                        )}
                        {(defaulttemplate || contractual || contractualDaily || contractualPayableDays || monthlyCtcTemplate) && (
                            <>
                                {step === 1 ? (
                                    <>
                                        <Grid container>
                                            {!contractual && !contractualDaily && !contractualPayableDays && !monthlyCtcTemplate &&
                                                (
                                                    <>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={6}
                                                            className={classes.flexAlignCenter}
                                                            sx={{
                                                                marginTop: "1rem"
                                                            }}
                                                        >
                                                            Enter CTC Amount here (Annually)
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={6}
                                                            sx={{
                                                                marginTop: "1rem",
                                                                px: "15px",
                                                                display: "flex",
                                                                justifyContent: "flex-end"
                                                            }}
                                                        >
                                                            <FormControl fullWidth>
                                                                <TextField
                                                                    size="small"
                                                                    type="number"
                                                                    onWheel={(e) => e.target.blur()}
                                                                    value={template?.ctc}
                                                                    onChange={handleInputTemplate}
                                                                    variant={"standard"}
                                                                    fullWidth
                                                                    id="ctc"
                                                                    label=""
                                                                    name="ctc"
                                                                    autoComplete="ctc"
                                                                    {...(temperrors.ctc && {
                                                                        error: true,
                                                                        helperText: temperrors.ctc,
                                                                    })}
                                                                />
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={6}
                                                            className={classes.flexAlignCenter}
                                                            sx={{
                                                                marginTop: "1rem",
                                                            }}
                                                        >
                                                            Basic
                                                            {selecttemp && (
                                                                <LightTooltip title="Basic is derived from the fixed portion of the CTC, after accounting for any variable pay." arrow>
                                                                    <Box sx={{ ml: 0.5, display: "flex" }}>
                                                                        <ErrorOutlineIcon
                                                                            sx={{ cursor: "pointer", fontSize: "16px", color: "#999" }}
                                                                        />
                                                                    </Box>
                                                                </LightTooltip>
                                                            )}
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={6}
                                                            sx={{
                                                                marginTop: "1rem",
                                                                px: "15px",
                                                                display: "flex",
                                                                justifyContent: "flex-end"
                                                            }}
                                                        >
                                                            <FormControl fullWidth>
                                                                <TextField
                                                                    size="small"
                                                                    placeholder="e.g. 50%"
                                                                    value={template?.basic}
                                                                    type="number"
                                                                    onChange={(e) => {
                                                                        const val = e.target.value;
                                                                        if (val === "" || (Number(val) >= 0 && Number(val) <= 100)) {
                                                                            handleInputTemplate(e);
                                                                        }
                                                                    }}
                                                                    InputProps={{
                                                                        endAdornment: (
                                                                            <InputAdornment position="start">
                                                                                %
                                                                            </InputAdornment>
                                                                        ),
                                                                        maxLength: 4,
                                                                    }}
                                                                    variant={"standard"}
                                                                    fullWidth
                                                                    id="basic"
                                                                    label=""
                                                                    name="basic"
                                                                    autoComplete="basic"
                                                                    {...(temperrors.basic && {
                                                                        error: true,
                                                                        helperText: temperrors.basic,
                                                                    })}
                                                                />
                                                            </FormControl>
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={6}
                                                            className={classes.flexAlignCenter}
                                                            sx={{
                                                                marginTop: "1rem",
                                                            }}
                                                        >
                                                            HRA
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={6}
                                                            sx={{
                                                                marginTop: "1rem",
                                                                px: "15px",
                                                                display: "flex",
                                                                justifyContent: "flex-end"
                                                            }}
                                                        >
                                                            <FormControl fullWidth>
                                                                <TextField
                                                                    size="small"
                                                                    placeholder="e.g. 50%"
                                                                    type="number"
                                                                    value={template?.hra}
                                                                    onChange={handleInputTemplate}
                                                                    InputProps={{
                                                                        endAdornment: (
                                                                            <InputAdornment position="start">
                                                                                %
                                                                            </InputAdornment>
                                                                        ),
                                                                        maxLength: 4,
                                                                    }}
                                                                    variant={"standard"}
                                                                    fullWidth
                                                                    id="hra"
                                                                    label=""
                                                                    name="hra"
                                                                    autoComplete="hra"
                                                                    {...(temperrors.hra && {
                                                                        error: true,
                                                                        helperText: temperrors.hra,
                                                                    })}
                                                                />
                                                            </FormControl>
                                                        </Grid>
                                                    </>
                                                )}
                                            {selecttemp && (
                                                <>
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        md={6}
                                                        className={classes.flexAlignCenter}
                                                        sx={{
                                                            marginTop: "1rem",
                                                        }}
                                                    >
                                                        Variable  <LightTooltip title="If variable pay is enabled, it is calculated first from the monthly CTC before computing the rest of the salary components." arrow>
                                                            <Box sx={{ ml: 0.5, display: "flex" }}>
                                                                <ErrorOutlineIcon
                                                                    sx={{ cursor: "pointer", fontSize: "16px", color: "#999" }}
                                                                />
                                                            </Box>
                                                        </LightTooltip>
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        md={6}
                                                        sx={{
                                                            marginTop: "1rem",
                                                            px: "15px",
                                                            display: "flex",
                                                            justifyContent: "flex-end"
                                                        }}
                                                    >
                                                        <FormControl fullWidth>
                                                            <TextField
                                                                size="small"
                                                                placeholder="e.g. 10%"
                                                                required
                                                                type="number"
                                                                value={template?.variable_percentage}
                                                                onChange={handleInputTemplate}
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <InputAdornment position="start">
                                                                            %
                                                                        </InputAdornment>
                                                                    ),
                                                                    maxLength: 4,
                                                                }}
                                                                variant={"standard"}
                                                                fullWidth
                                                                id="variable_percentage"
                                                                label=""
                                                                name="variable_percentage"
                                                                autoComplete="variable_percentage"
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                </>
                                            )}
                                            {(selecttemp || contractual || contractualDaily || contractualPayableDays || monthlyCtcTemplate) && (
                                                <>
                                                    <Grid item xs={12} md={12}
                                                        sx={{
                                                            marginTop: "1rem",
                                                            paddingRight: "0px",
                                                            paddingLeft: "0px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: 2
                                                        }}
                                                    >
                                                        {/* Header Row */}
                                                        <Grid container>
                                                            <Grid item xs={12} md={6} sx={{ padding: "0 15px" }}>
                                                                <Box sx={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    alignItems: "center"
                                                                }}>
                                                                    {/* // Advance, Contractual and ContractualDaily*/}
                                                                    <Typography
                                                                        variant="h6"
                                                                        gutterBottom
                                                                    >
                                                                        Earnings
                                                                    </Typography>
                                                                    <Tooltip title="Add">
                                                                        <IconButton
                                                                            disabled={disabledEarningTemplate || disabled}
                                                                            className="mpl-primary-btn"
                                                                            onClick={handleAddEarningFields}
                                                                            style={{ padding: '4px', minWidth: '30px', height: '30px' }}
                                                                        >
                                                                            <AddIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </Box>
                                                            </Grid>
                                                            <Grid item xs={12} md={6} sx={{ padding: "0 15px" }}>
                                                                <Typography
                                                                    variant="h6"
                                                                    gutterBottom
                                                                >
                                                                    Monthly
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                        <Box sx={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: 2
                                                        }}>
                                                            {templateEarningData?.map((res, id) => (
                                                                <Grid container key={id} sx={{
                                                                    width: "100%",
                                                                    alignItems: "center"
                                                                }}>
                                                                    <Grid item xs={12} md={6} sx={{ padding: "0 15px" }}>
                                                                        <FormControl fullWidth>
                                                                            <SelectableSearch
                                                                                isOptionEqualToValue={(option, value) =>
                                                                                    option?.name === value?.name
                                                                                }
                                                                                label="Select an Earnings"
                                                                                fullWidth
                                                                                disabled={disabled || (res?.earning_key?.name === "basic" && (contractual || contractualDaily || contractualPayableDays || monthlyCtcTemplate))}
                                                                                value={res?.earning_key}
                                                                                loading={() => handleEarnings()}
                                                                                fieldLabel="label"
                                                                                required={false}
                                                                                variantType={"standard"}
                                                                                name="earning_key"
                                                                                size="small"
                                                                                onChangeEvent={(e, newValue) =>
                                                                                    handleEarningChange("earning_key", newValue, id)
                                                                                }
                                                                                data={{ load: earningData.load, values: getFilteredEarnings(id) }}
                                                                                {...(templateEarningErrors[id] &&
                                                                                    templateEarningErrors[id].earning_key && {
                                                                                    error: true,
                                                                                    helperText: templateEarningErrors[id].earning_key,
                                                                                })}
                                                                            />
                                                                        </FormControl>
                                                                    </Grid>
                                                                    <Grid item xs={12} md={6} sx={{ padding: "0 15px", marginTop: "15px" }}>
                                                                        <FormControl fullWidth>
                                                                            <TextField
                                                                                size="small"
                                                                                required
                                                                                value={res.earning_value}
                                                                                onChange={(e) => {
                                                                                    const value = e.target.value;
                                                                                    if (/^\d*\.?\d*$/.test(value)) {
                                                                                        handleEarningChange(e.target.name, value, id);
                                                                                    }
                                                                                }}
                                                                                variant="standard"
                                                                                fullWidth
                                                                                disabled={disabled}
                                                                                id="earning_value"
                                                                                label=""
                                                                                name="earning_value"
                                                                                autoComplete="earning_value"
                                                                                inputProps={{
                                                                                    inputMode: 'decimal',
                                                                                    pattern: "[0-9]*",
                                                                                    step: "0.01",
                                                                                }}
                                                                                InputProps={{
                                                                                    endAdornment: (
                                                                                        <InputAdornment position="end">
                                                                                            {!disabled && (
                                                                                                <IconButton
                                                                                                    onClick={(e) => handleEarningDelete(e, id, res?.certificate_id)}
                                                                                                    size="small"
                                                                                                    sx={{ ml: 1 }}
                                                                                                    disabled={(res?.earning_key?.name === "basic" && (contractual || contractualDaily || contractualPayableDays || monthlyCtcTemplate))}
                                                                                                >
                                                                                                    <DeleteIcon color={(res?.earning_key?.name === "basic" && (contractual || contractualDaily || contractualPayableDays || monthlyCtcTemplate)) ? "disabled" : "error"} fontSize="small" />
                                                                                                </IconButton>
                                                                                            )}
                                                                                        </InputAdornment>
                                                                                    ),
                                                                                }}
                                                                                {...(templateEarningErrors[id]?.earning_value && {
                                                                                    error: true,
                                                                                    helperText: templateEarningErrors[id].earning_value,
                                                                                })}
                                                                            />
                                                                        </FormControl>
                                                                    </Grid>
                                                                </Grid>
                                                            ))}
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={12} md={12}
                                                        sx={{
                                                            marginTop: "1rem",
                                                            paddingRight: "0px",
                                                            paddingLeft: "0px",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: 2
                                                        }}
                                                    >
                                                        {/* Header Row */}
                                                        <Grid container>
                                                            <Grid item xs={12} md={6} sx={{ padding: "0 15px" }}>
                                                                <Box sx={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    alignItems: "center"
                                                                }}>
                                                                    <Typography
                                                                        variant="h6"
                                                                        gutterBottom
                                                                    >
                                                                        Deductions
                                                                    </Typography>
                                                                    <Tooltip title="Add">
                                                                        <IconButton
                                                                            disabled={disabledDeductionTemplate || disabled}
                                                                            className="mpl-primary-btn"
                                                                            style={{ padding: '4px', minWidth: '30px', height: '30px' }}
                                                                            onClick={handleAddDeductionFields}
                                                                        >
                                                                            <AddIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </Box>
                                                            </Grid>
                                                            <Grid item xs={12} md={6} sx={{ padding: "0 15px" }}>
                                                                <Typography
                                                                    variant="h6"
                                                                    gutterBottom
                                                                >
                                                                    Monthly
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                        <Box sx={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: 2
                                                        }}>
                                                            {templateDeductionData?.map((res, id) => (
                                                                <Grid container key={id} sx={{
                                                                    width: "100%",
                                                                    alignItems: "center"
                                                                }}>
                                                                    <Grid item xs={12} md={6} sx={{ padding: "0 15px" }}>
                                                                        <FormControl fullWidth>
                                                                            <SelectableSearch
                                                                                isOptionEqualToValue={(option, value) =>
                                                                                    option?.name === value?.name
                                                                                }
                                                                                label="Select an Deductions"
                                                                                fullWidth
                                                                                disabled={disabled}
                                                                                value={res?.deduction_key}
                                                                                loading={() => handleDeduction()}
                                                                                fieldLabel="label"
                                                                                required={false}
                                                                                variantType={"standard"}
                                                                                name="deduction_key"
                                                                                size="small"
                                                                                onChangeEvent={(e, newValue) =>
                                                                                    handleDeductionChange("deduction_key", newValue, id)
                                                                                }
                                                                                data={{ load: deductionData.load, values: getFilteredDeduction(id) }}
                                                                                {...(templateDeductionErrors[id] &&
                                                                                    templateDeductionErrors[id].deduction_key && {
                                                                                    error: true,
                                                                                    helperText: templateDeductionErrors[id].deduction_key,
                                                                                })}
                                                                            />
                                                                        </FormControl>
                                                                    </Grid>
                                                                    <Grid item xs={12} md={6} sx={{ padding: "0 15px", marginTop: "15px" }}>
                                                                        <FormControl fullWidth>
                                                                            <TextField
                                                                                size="small"
                                                                                required
                                                                                value={res.deduction_value}
                                                                                onChange={(e) => {
                                                                                    const value = e.target.value;
                                                                                    if (/^\d*\.?\d*$/.test(value)) {
                                                                                        handleDeductionChange(e.target.name, value, id);
                                                                                    }
                                                                                }}
                                                                                variant={"standard"}
                                                                                fullWidth
                                                                                id="deduction_value"
                                                                                disabled={disabled}
                                                                                label=""
                                                                                name="deduction_value"
                                                                                autoComplete="deduction_value"
                                                                                inputProps={{
                                                                                    inputMode: 'decimal',
                                                                                    pattern: "[0-9]*",
                                                                                    step: "0.01"
                                                                                }}
                                                                                InputProps={{
                                                                                    endAdornment: (
                                                                                        <InputAdornment position="end">
                                                                                            {!disabled && (
                                                                                                <DeleteIcon
                                                                                                    color="error"
                                                                                                    onClick={(e) => handleDeductionDelete(e, id, res?.certificate_id)}
                                                                                                    fontSize="small"
                                                                                                    sx={{ cursor: "pointer", marginLeft: 1 }}
                                                                                                />
                                                                                            )}
                                                                                        </InputAdornment>
                                                                                    ),
                                                                                }}
                                                                                {...(templateDeductionErrors[id] &&
                                                                                    templateDeductionErrors[id].deduction_value && {
                                                                                    error: true,
                                                                                    helperText: templateDeductionErrors[id].deduction_value,
                                                                                })}
                                                                            />
                                                                        </FormControl>
                                                                    </Grid>
                                                                </Grid>
                                                            ))}
                                                        </Box>
                                                    </Grid>
                                                </>
                                            )}


                                            {!monthlyCtcTemplate && allowances?.map(({ label, flagName, valueName }) => (
                                                <AllowanceInput
                                                    key={flagName}
                                                    label={label}
                                                    flagName={flagName}
                                                    valueName={valueName}
                                                    template={template}
                                                    handleToggle={handleToggle}
                                                    handleInputTemplate={handleInputTemplate}
                                                    errors={valueName ? temperrors?.[valueName] : null}
                                                />
                                            ))}
                                            <Grid container xs={12}>
                                                <AllowanceInput
                                                    key={"esic"}
                                                    label={"ESIC"}
                                                    flagName={"esic"}
                                                    template={template}
                                                    handleToggle={() => handleToggle1("esic")}
                                                    isAllowed={!!empRegNumber?.esi_no}
                                                    notAllowedMessage="ESI number is not set."
                                                    setEmpRegNumber={setEmpRegNumber}
                                                    empRegNumber={empRegNumber}
                                                    currentData={currentData}
                                                    buttonLabel="Add ESI Number"
                                                    disabled={shouldDisableEsic({ esic: esicInfo?.toggle, esic_modifiedon: esicInfo?.lastModified })}
                                                />
                                            </Grid>
                                            <AllowanceInput
                                                key={"pt"}
                                                label={"PT"}
                                                flagName={"pt"}
                                                template={template}
                                                handleToggle={() => handleToggle1("pt")}
                                            />
                                            <Grid
                                                item
                                                xs={12}
                                                md={6}
                                                sx={{
                                                    marginTop: "1rem",
                                                    px: "15px",

                                                }}
                                            ></Grid>
                                            <AllowanceInput
                                                key={"statutory_bonus_flag"}
                                                label={"Statutory Bonus"}
                                                flagName={"statutory_bonus_flag"}
                                                template={template}
                                                handleToggle={() => handleToggle1("statutory_bonus_flag")}
                                            />
                                            {(defaulttemplate || monthlyCtcTemplate) && (
                                                <AllowanceInput
                                                    key={"gratuity_flag"}
                                                    label={"Gratuity"}
                                                    flagName={"gratuity_flag"}
                                                    template={template}
                                                    handleToggle={() => handleToggle1("gratuity_flag")}
                                                />
                                            )}
                                            <>
                                                <Grid item xs={12} mb={template?.pf ? "10px" : "0px"} >
                                                    <Box
                                                        sx={{
                                                            borderRadius: "8px",
                                                            padding: "1rem 15px",
                                                            background: template?.pf ? "#f4f2f7" : "none",
                                                            width: "100%",
                                                        }}
                                                    >
                                                        <Grid container spacing={2}>
                                                            <AllowanceInput
                                                                key={"pf_compliant_flag"}
                                                                label={"PF Compliant Tag"}
                                                                flagName={"pf_compliant_flag"}
                                                                template={template}
                                                                handleToggle={() => handleToggle1("pf_compliant_flag")}
                                                                disabled={template?.pf}
                                                            />
                                                            <AllowanceInput
                                                                key={"pf"}
                                                                label={"PF"}
                                                                flagName={"pf"}
                                                                template={template}
                                                                handleToggle={() => handleToggle1("pf")}
                                                                isAllowed={!!empRegNumber?.pf_no}
                                                                notAllowedMessage="EPF number is not set."
                                                                setEmpRegNumber={setEmpRegNumber}
                                                                empRegNumber={empRegNumber}
                                                                currentData={currentData}
                                                                buttonLabel="Add EPF Number"
                                                            />
                                                            {template?.pf && (
                                                                <AllowanceInput
                                                                    key={"eps_applicable_flag"}
                                                                    label={"EPS"}
                                                                    flagName={"eps_applicable_flag"}
                                                                    template={template}
                                                                    handleToggle={() => handleToggle1("eps_applicable_flag")}
                                                                />
                                                            )}
                                                        </Grid>
                                                        {template?.pf && (
                                                            <Grid container spacing={2}>
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    md={6}
                                                                    sx={{
                                                                        marginTop: "1rem",
                                                                        paddingLeft: "15px",
                                                                        paddingRight: "7px",
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    Set PF Limit
                                                                    <div>
                                                                        <FormGroup>
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Switch
                                                                                        onChange={() => handleToggle1("pf_limit_applicable")}
                                                                                        checked={template?.pf_limit_applicable}
                                                                                    />
                                                                                }
                                                                            />
                                                                        </FormGroup>
                                                                    </div>
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    md={6}
                                                                    sx={{
                                                                        marginTop: "1rem",
                                                                        px: "15px",
                                                                        display: "flex",
                                                                        justifyContent: "flex-end",
                                                                        alignItems: "center"
                                                                    }}
                                                                >
                                                                    {(template?.pf && template?.pf_limit_applicable) && (
                                                                        <FormControl fullWidth>
                                                                            <TextField
                                                                                size="small"
                                                                                type="number"
                                                                                required
                                                                                value={template?.pf_limit_amount}
                                                                                onChange={handleInputTemplate}
                                                                                variant={"standard"}
                                                                                fullWidth
                                                                                id="pf_limit_amount"
                                                                                label="PF Amount"
                                                                                name="pf_limit_amount"
                                                                                autoComplete="pf_limit_amount"
                                                                                {...(temperrors.pf_limit_amount && {
                                                                                    error: true,
                                                                                    helperText: temperrors.pf_limit_amount,
                                                                                })}
                                                                            />
                                                                        </FormControl>
                                                                    )}
                                                                </Grid>
                                                            </Grid>
                                                        )}
                                                    </Box>
                                                </Grid>
                                            </>
                                            <OvertimeSelector
                                                disabled={disabled}
                                                overtime={overtime}
                                                handleInputChange={handleInputChange1}
                                                handleOvertimeOptions={handleOvertimeOptions}
                                                handleOverTimeChange={handleOverTimeChange}
                                                overtimeOptionData={overtimeOptionData}
                                                temperrors={temperrors}
                                            />

                                            {(defaulttemplate || contractual || contractualDaily || contractualPayableDays || monthlyCtcTemplate) &&
                                                (<Grid container xs={12} mt="1rem" >
                                                    {/* Only Contractual */}
                                                    {(contractual || contractualDaily || contractualPayableDays) &&
                                                        <>
                                                            <Grid xs={12} sm={6} md={6} pl={"15px"}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            disabled={disabled}
                                                                            name="leave_wages_applicable"
                                                                            checked={template?.leave_wages_applicable || false}
                                                                            onChange={handleInputChange1}
                                                                        />
                                                                    }
                                                                    label={
                                                                        <span>
                                                                            Leave Wages&nbsp;
                                                                            <Tooltip title={leave_wage_data?.[0]?.standard_paid_days ? `Calculated from earnings and attendance using a company-defined multiplier (e.g. ${leave_wage_data?.[0]?.standard_paid_days || "N/A"} / ${leave_wage_data?.[0]?.leave_eligibility_days || "N/A"}) to reflect statutory leave entitlement.` : ""} arrow>
                                                                                <InfoOutlinedIcon fontSize="small" color="action" style={{ verticalAlign: "middle", cursor: "pointer" }} />
                                                                            </Tooltip>
                                                                        </span>
                                                                    }
                                                                />
                                                            </Grid>
                                                            <Grid xs={12} sm={6} md={6} pl={"15px"}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            disabled={disabled}
                                                                            name="ph_wages_applicable"
                                                                            checked={template?.ph_wages_applicable || false}
                                                                            onChange={handleInputChange1}
                                                                        />
                                                                    }
                                                                    label={
                                                                        <span>
                                                                            Public Holiday Wages&nbsp;
                                                                            <Tooltip title={ph_allowance_data?.[0]?.ph_allowance_type ? `It is paid to employees who work on public holidays. It can be configured as a fixed amount or linked to earnings. ${ph_allowance_data?.[0]?.ph_allowance_type === "Flat" ? `Currently set as a fixed amount of ₹${ph_allowance_data?.[0]?.flat_amount || "N/A"}.` : `Currently linked to earnings.`}` : ""} arrow>
                                                                                <InfoOutlinedIcon fontSize="small" color="action" style={{ verticalAlign: "middle", cursor: "pointer" }} />
                                                                            </Tooltip>
                                                                        </span>
                                                                    }
                                                                />
                                                            </Grid> </>}
                                                    {/* All Meepl Temp */}
                                                    <>
                                                        <Grid item xs={12} sm={6} md={6}>
                                                            <Box sx={{ width: "90%", padding: "0px 15px", borderRadius: "8px", background: template?.transport_applicable ? "#f4f2f7" : "none", }}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            disabled={disabled}
                                                                            name="transport_applicable"
                                                                            checked={template?.transport_applicable || false}
                                                                            onChange={handleInputChange1}
                                                                        />
                                                                    }
                                                                    label={
                                                                        <span>
                                                                            Transport Allowance&nbsp;
                                                                            <Tooltip title={transport_allowance_data?.[0]?.transport_allowance_type ? `It compensates for travel expenses and can be configured as either a fixed monthly amount or a variable daily rate. ${transport_allowance_data?.[0]?.transport_allowance_type === "Flat" ? `Currently set as a fixed monthly amount of ₹${transport_allowance_data?.[0]?.flat_amount || "N/A"}.` : `Currently set to Variable daily rate.`}` : ""} arrow>
                                                                                <InfoOutlinedIcon fontSize="small" color="action" style={{ verticalAlign: "middle", cursor: "pointer" }} />
                                                                            </Tooltip>
                                                                        </span>
                                                                    }
                                                                />

                                                                {template?.transport_applicable && (
                                                                    <Box ml={"4px"}>
                                                                        <FormControl component="fieldset">
                                                                            <FormLabel component="legend"> Allowance As</FormLabel>
                                                                            <RadioGroup
                                                                                row
                                                                                name="transport_type"
                                                                                value={template?.transport_earnings ? "earning" : template?.transport_deductions ? "deduction" : ""}
                                                                                onChange={handleInputChange1}
                                                                                sx={{ display: "flex", flexDirection: "row", alignItems: "center", ml: "5px" }} // Ensures flex row
                                                                            >
                                                                                <FormControlLabel
                                                                                    value="earning"
                                                                                    control={
                                                                                        <Radio
                                                                                            size="small"
                                                                                            sx={{ p: 0.5, mr: 0.5 }}
                                                                                            checked={!!template?.transport_earnings}

                                                                                        />
                                                                                    }
                                                                                    label={<span style={{ fontSize: "0.95rem" }}>Earning</span>}
                                                                                    sx={{ mr: 2, minWidth: 0 }}
                                                                                />
                                                                                <FormControlLabel
                                                                                    value="deduction"
                                                                                    control={
                                                                                        <Radio
                                                                                            size="small"
                                                                                            sx={{ p: 0.5, mr: 0.5 }}
                                                                                            checked={!!template?.transport_deductions}
                                                                                        />
                                                                                    }
                                                                                    label={<span style={{ fontSize: "0.95rem" }}>Deduction</span>}
                                                                                    sx={{ minWidth: 0 }}
                                                                                />
                                                                            </RadioGroup>
                                                                        </FormControl>
                                                                    </Box>
                                                                )}
                                                                {/* show error */}
                                                                {duplicateError?.transport_applicable && (
                                                                    <FormHelperText error={true}>{duplicateError?.transport_applicable}</FormHelperText>
                                                                )}
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={6}>
                                                            <Box sx={{ width: "90%", padding: "0px 15px", borderRadius: "8px", background: template?.food_applicable ? "#f4f2f7" : "none" }}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            disabled={disabled}
                                                                            name="food_applicable"
                                                                            checked={template?.food_applicable || false}
                                                                            onChange={handleInputChange1}
                                                                        />
                                                                    }
                                                                    label={
                                                                        <span>
                                                                            Food Allowance&nbsp;
                                                                            <Tooltip title={food_allowance_data?.[0]?.food_allowance_type ? `Food-based earning or deduction. Supports fixed or daily-amount calculations with eligibility rules. ${food_allowance_data?.[0]?.food_allowance_type === "Flat" ? `Currently set as a fixed monthly amount of ₹${food_allowance_data?.[0]?.flat_amount || "N/A"}.` : `Currently set to Variable daily amount.`}` : ""} arrow>
                                                                                <InfoOutlinedIcon fontSize="small" color="action" style={{ verticalAlign: "middle", cursor: "pointer" }} />
                                                                            </Tooltip>
                                                                        </span>
                                                                    }
                                                                />

                                                                {template?.food_applicable && (
                                                                    <Box ml={"4px"}>
                                                                        <FormControl component="fieldset">
                                                                            <FormLabel component="legend"> Allowance As</FormLabel>
                                                                            <RadioGroup
                                                                                row
                                                                                name="food_type"
                                                                                value={template?.food_earnings ? "earning" : template?.food_deductions ? "deduction" : ""}
                                                                                onChange={handleInputChange1}
                                                                                sx={{ display: "flex", flexDirection: "row", alignItems: "center", ml: "5px" }} // Ensures flex row
                                                                            >
                                                                                <FormControlLabel
                                                                                    value="earning"
                                                                                    control={
                                                                                        <Radio
                                                                                            size="small"
                                                                                            sx={{ p: 0.5, mr: 0.5 }}
                                                                                            checked={!!template?.food_earnings}

                                                                                        />
                                                                                    }
                                                                                    label={<span style={{ fontSize: "0.95rem" }}>Earning</span>}
                                                                                    sx={{ mr: 2, minWidth: 0 }}
                                                                                />
                                                                                <FormControlLabel
                                                                                    value="deduction"
                                                                                    control={
                                                                                        <Radio
                                                                                            size="small"
                                                                                            sx={{ p: 0.5, mr: 0.5 }}
                                                                                            checked={!!template?.food_deductions}
                                                                                        />
                                                                                    }
                                                                                    label={<span style={{ fontSize: "0.95rem" }}>Deduction</span>}
                                                                                    sx={{ minWidth: 0 }}
                                                                                />
                                                                            </RadioGroup>
                                                                        </FormControl>
                                                                    </Box>

                                                                )}
                                                                {/* show error  */}
                                                                {duplicateError?.food_applicable && (
                                                                    <FormHelperText error={true}>{duplicateError?.food_applicable}</FormHelperText>
                                                                )}
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={6} pl={"15px"}>
                                                            <FormGroup>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            disabled={disabled}
                                                                            checked={template.weekoff_caln_applicable}
                                                                            onChange={handleInputChange1}
                                                                            name="weekoff_caln_applicable"
                                                                        />
                                                                    }
                                                                    label={
                                                                        <span>
                                                                            Include Paid Week Offs&nbsp;
                                                                            <Tooltip title="When enabled, week offs will be marked as paid." arrow>
                                                                                <InfoOutlinedIcon fontSize="small" color="action" style={{ verticalAlign: "middle", cursor: "pointer" }} />
                                                                            </Tooltip>
                                                                        </span>
                                                                    }
                                                                />
                                                            </FormGroup>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={6} pl={"15px"}>
                                                            <FormGroup>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            disabled={disabled}
                                                                            checked={template.monthly_working_hrs_calc}
                                                                            onChange={handleInputChange1}
                                                                            name="monthly_working_hrs_calc"
                                                                        />
                                                                    }
                                                                    label={
                                                                        <span>
                                                                            Monthly Working Hrs Cal.&nbsp;
                                                                            <Tooltip title="When enabled, paid days are calculated based on the employee's total monthly working hours across expected monthly working hours. Daily attendance hours are not evaluated individually." arrow>
                                                                                <InfoOutlinedIcon fontSize="small" color="action" style={{ verticalAlign: "middle", cursor: "pointer" }} />
                                                                            </Tooltip>
                                                                        </span>
                                                                    }
                                                                />
                                                            </FormGroup>
                                                        </Grid>
                                                    </>
                                                </Grid>)}
                                            {monthlyCtcTemplate &&
                                                <>
                                                    <Grid item xs={12}>
                                                        <Divider sx={{ mt: 1 }} />
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        md={6}
                                                        className={classes.flexAlignCenter}
                                                        sx={{
                                                            marginTop: "1rem"
                                                        }}
                                                    >
                                                        {"Annual Gross Salary"}&nbsp;
                                                        <>
                                                            <LightTooltip title="Please note that this is an estimated annual gross salary. ESIC and EPF contributions may adjust the final amount." arrow>
                                                                <Box sx={{ ml: 0.5, display: "flex" }}>
                                                                    <ErrorOutlineIcon
                                                                        sx={{ cursor: "pointer", fontSize: "16px", color: "#999" }}
                                                                    />
                                                                </Box>
                                                            </LightTooltip>
                                                            <span style={{ paddingLeft: "50px", paddingBottom: "2px" }}>:</span>
                                                        </>
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        md={6}
                                                        sx={{
                                                            marginTop: "1rem",
                                                            px: "15px",
                                                            display: "flex",
                                                            justifyContent: "flex-end"
                                                        }}
                                                    >
                                                        <FormControl fullWidth>
                                                            <Typography variant="body1" fontWeight={600} color={"inherit"} >
                                                                {template?.ctc
                                                                    ? Number(template.ctc) % 1 === 0
                                                                        ? Number(template.ctc)
                                                                        : Number(template.ctc).toFixed(3)
                                                                    : ""
                                                                }
                                                            </Typography>
                                                        </FormControl>
                                                    </Grid>
                                                </>
                                            }
                                            <Box sx={{
                                                width: "100%",
                                                mt: 3,
                                                display: "flex",
                                                justifyContent: "space-between",
                                                gap: "10px"
                                            }}>
                                                <Button onClick={() => { setOpenTemplate(false); }} size="small" variant="outlined">
                                                    Cancel
                                                </Button>
                                                <Button disabled={isSending} onClick={handleNext} size="small" variant="outlined">
                                                    Next
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </>
                                ) : (
                                    <div> {/* Screen 2 */}
                                        <Grid container spacing={2} sx={{ paddingLeft: "15px", marginBottom: "1rem", }}>
                                            <Grid item xs={12} md={5} className={classes.flexAlignCenter}>
                                                <Typography variant="h6" style={{ marginTop: "1rem", }}>
                                                    Earnings
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} md={3.5} className={classes.flexAlignCenter}>
                                                <Typography variant="h6" style={{ marginTop: "1rem", }}>
                                                    Monthly
                                                </Typography>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                md={3.5}
                                                className={classes.flexAlignCenter}
                                            >
                                                <Typography variant="h6" style={{ marginTop: "1rem", }}>
                                                    Annually
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2} sx={{ paddingLeft: "15px" }}>
                                            {earningsComp
                                                .filter(item =>
                                                    item.value !== null &&
                                                    item.value !== "0" &&
                                                    item.value !== 0 &&
                                                    item.annual_val !== null &&
                                                    item.annual_val !== "0" &&
                                                    item.annual_val !== 0
                                                )
                                                .sort((a, b) => sanitizeNumber(b.value) - sanitizeNumber(a.value))
                                                .map((item, index) => (
                                                    <React.Fragment key={index}>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={5}
                                                            className={classes.flexAlignCenter}
                                                        >
                                                            <Box display="flex" alignItems="center">
                                                                <Typography variant="body1" sx={{ marginRight: "0.5rem", color: "inherit" }}>
                                                                    {item.label}
                                                                </Typography>
                                                                {checkSpecialAllowanceNegative && item.label === "Special Allowance" &&
                                                                    <Tooltip title="Fixed components exceed CTC. Adjust values to avoid negative special allowance.">
                                                                        <WarningAmberIcon color="warning" fontSize="small" />
                                                                    </Tooltip>}
                                                            </Box>
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={3.5}
                                                            className={classes.flexAlignCenter}
                                                            sx={{
                                                                color: (checkSpecialAllowanceNegative && item.label === "Special Allowance") ? "red" : "none"
                                                            }}
                                                        >
                                                            {item.value}
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={3.5}
                                                            sx={{
                                                                px: "15px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                color: (checkSpecialAllowanceNegative && item.label === "Special Allowance") ? "red" : "none"
                                                            }}
                                                        >
                                                            {item.annual_val}
                                                        </Grid>
                                                    </React.Fragment>
                                                ))}
                                        </Grid>

                                        <Divider sx={{ mt: 2 }} />
                                        <Grid container spacing={2} sx={{ paddingLeft: "15px" }}>
                                            <Grid
                                                item
                                                xs={12}
                                                md={5}
                                                className={classes.flexAlignCenter}
                                            >
                                                <Typography variant="h6" gutterBottom style={{ marginTop: "2rem" }}>
                                                    Deductions
                                                </Typography>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                md={3.5}
                                                className={classes.flexAlignCenter}
                                            >
                                                <Typography variant="h6" gutterBottom style={{ marginTop: "2rem" }}>
                                                    Monthly
                                                </Typography>
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                md={3.5}
                                                className={classes.flexAlignCenter}
                                            >
                                                <Typography variant="h6" gutterBottom style={{ marginTop: "2rem" }}>
                                                    Annually
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2} sx={{ paddingLeft: "15px" }}>
                                            {deductionsComp
                                                .filter(item =>
                                                    item.value !== null &&
                                                    item.value !== "0" &&
                                                    item.value !== 0 &&
                                                    item.annual_val !== null &&
                                                    item.annual_val !== "0" &&
                                                    item.annual_val !== 0
                                                )
                                                .sort((a, b) => {
                                                    const valA = sanitizeNumber(a.value);
                                                    const valB = sanitizeNumber(b.value);
                                                    return valB - valA; // Descending order
                                                })
                                                .map((item, index) => (
                                                    <React.Fragment key={index}>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={5}
                                                            className={classes.flexAlignCenter}
                                                            sx={{
                                                                marginTop: "1rem",
                                                            }}
                                                        >
                                                            {item.label}
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={3.5}
                                                            className={classes.flexAlignCenter}
                                                            sx={{
                                                                marginTop: "1rem",
                                                            }}
                                                        >
                                                            {item.value}
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={3.5}
                                                            className={classes.flexAlignCenter}
                                                            sx={{
                                                                marginTop: "1rem",
                                                            }}
                                                        >
                                                            {item.annual_val}
                                                        </Grid>
                                                    </React.Fragment>
                                                ))}
                                        </Grid>
                                        <Divider sx={{ mt: 2 }} />
                                        <Grid container spacing={2} sx={{ mt: 2, paddingLeft: "15px" }} >
                                            <Grid container>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    md={5}
                                                    className={classes.flexAlignCenter}
                                                >
                                                    <Typography variant="h6" gutterBottom style={{ marginTop: "1rem" }}>
                                                        Gross
                                                    </Typography>
                                                </Grid>
                                                <Grid item
                                                    xs={12}
                                                    md={3.5}
                                                    className={classes.flexAlignCenter}>
                                                    <Typography variant="h6">Monthly</Typography>
                                                </Grid>
                                                <Grid item
                                                    xs={12}
                                                    md={3.5}
                                                    sx={{
                                                        px: "15px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}>
                                                    <Typography variant="h6">Annually</Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container alignItems="center" sx={{ mt: 1 }}>
                                                <Grid item
                                                    xs={12}
                                                    md={5}
                                                    className={classes.flexAlignCenter}>
                                                    <span className={classes.label}>Gross Earning Total</span>
                                                </Grid>
                                                <Grid item
                                                    xs={12}
                                                    md={3.5}
                                                    className={classes.flexAlignCenter}>
                                                    <span> {formattedGrossEarnings || 0}</span>
                                                </Grid>
                                                <Grid item
                                                    xs={12}
                                                    md={3.5}
                                                    className={classes.flexAlignCenter}>
                                                    <span>{formatNumber(grossEarningsTempTotal * 12) || 0}</span>
                                                </Grid>
                                            </Grid>
                                            <Grid container alignItems="center" sx={{ mt: 1 }}>
                                                <Grid item
                                                    xs={12}
                                                    md={5}
                                                    className={classes.flexAlignCenter}>
                                                    <span className={classes.label}>Gross Deduction Total</span>
                                                </Grid>
                                                <Grid item
                                                    xs={12}
                                                    md={3.5}
                                                    className={classes.flexAlignCenter}>
                                                    <span> {formattedGrossDeductions || 0}</span>
                                                </Grid>
                                                <Grid item
                                                    xs={12}
                                                    md={3.5}
                                                    className={classes.flexAlignCenter}>
                                                    <span>{formatNumber(grossDeductionsTempTotal * 12) || 0}</span>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Divider sx={{ mb: 2 }} />
                                            </Grid>
                                            <Grid container alignItems="center" sx={{ fontWeight: "bold" }}>
                                                <Grid item
                                                    xs={12}
                                                    md={5}
                                                    className={classes.flexAlignCenter}>
                                                    <span className={classes.netlabel}>Net Total</span>
                                                </Grid>
                                                <Grid item
                                                    xs={12}
                                                    md={3.5}
                                                    className={classes.flexAlignCenter}>
                                                    <span> {formattedNetTotal || 0}</span>
                                                </Grid>
                                                <Grid item
                                                    xs={12}
                                                    md={3.5}
                                                    className={classes.flexAlignCenter}>
                                                    <span> {formatNumber(netTempTotal * 12) || 0}</span>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Box sx={{
                                            width: "100%",
                                            mt: 3,
                                            display: "flex",
                                            justifyContent: "space-between",
                                        }}>
                                            <Button onClick={() => { setStep(1); }} size="small" variant="outlined">
                                                Back
                                            </Button>
                                            <Tooltip title={checkSpecialAllowanceNegative ? "Cannot submit while Special Allowance is negative." : ""} placement="top">
                                                <Box>
                                                    <Button disabled={isSending || checkSpecialAllowanceNegative} onClick={handleSubmitTemp} size="small" variant="outlined">
                                                        Submit
                                                    </Button>
                                                </Box>
                                            </Tooltip>
                                        </Box>
                                    </div>
                                )}
                            </>
                        )}

                    </Box>
                </>
            )}
            <Popup
                maxWidth="sm"
                fullWidth={true}
                title="Enter Template Name"
                openPopup={opentempname}
                setOpenPopup={setOpenTempname}
            >
                <FormControl fullWidth>
                    <TextField
                        size="small"
                        required
                        value={templatename?.template_name}
                        onChange={handleInputChange}
                        variant="outlined"
                        fullWidth
                        id="template_name"
                        label="Template Name"
                        name="template_name"
                        autoComplete="template_name"
                        {...(errors.template_name && {
                            error: true,
                            helperText: errors.template_name,
                        })}
                    />
                </FormControl>
                <Box sx={{
                    width: "100%",
                    mt: 3,
                    display: "flex",
                    justifyContent: "space-between",
                }}>
                    <Button onClick={() => { setOpenTempname(false); }} size="small" variant="outlined">
                        Cancel
                    </Button>
                    <Button onClick={handleCreateTemplate} size="small" variant="outlined">
                        Save
                    </Button>
                </Box>
            </Popup>
            <Popup
                maxWidth="sm"
                fullWidth={true}
                title="Warning"
                openPopup={openvalid}
                setOpenPopup={setOpenValid}
            >
                <Typography variant="h6" gutterBottom style={{ display: "flex", justifyContent: "center" }}>
                    Given CTC is not Matching Gross Earning
                </Typography>
                <Box sx={{
                    width: "100%",
                    mt: 3,
                    display: "flex",
                    justifyContent: "center",
                }}>
                    <Button onClick={() => { setOpenValid(false); }} size="small" variant="outlined">
                        Ok
                    </Button>

                </Box>
            </Popup>
            <Popup
                maxWidth="xs"
                close={false}
                hideDividers={true}
                openPopup={onhold}
                setOpenPopup={setOnHold}
            >
                <Box
                    sx={{
                        width: "250px",
                        height: "120px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        alignItems: "center",
                        borderRadius: 2,
                    }}
                >
                    <Typography
                        variant="h6"
                        gutterBottom
                        sx={{ textAlign: "center", mt: 1 }}
                    >
                        {msg}
                    </Typography>

                    <Box
                        sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "space-around",

                        }}
                    >
                        <Button
                            onClick={() => handleCancel()}
                            size="small"
                            variant="outlined"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={() => handleOnhold()}
                            size="small"
                            variant="outlined"
                        >
                            Yes
                        </Button>
                    </Box>
                </Box>
            </Popup>

        </>
    );
}

export default EmployeePayroleTemplate;